
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      import '../dhtmlxscheduler_collision.js';
import '../css/new-calendar.css';
import actions from "../js/actions.js";
import $$ from "Dom7";
import URLS from "../js/Urls.js";

var moment = require('moment');

var today = moment();
var currentTime = new Date();
let calendarRangeFrom2;
var JsYear = currentTime.getFullYear();
var JsMonth = currentTime.getMonth(); // Real Month-1

var JsDay = currentTime.getDate();
var FilterShowRoomCategories = 1;
var WebRootPath = 'https://pms.abouthotelier.com';
var HitIt = 1;
var CountHROM = 0;
var CheckALEL = 0;
var loginobject = actions.LoginGetResult();
var SimpleEventStyle = 1;
var schdResBasicsSimpleClass = "schdResBasicsSimpleNormal";
var ToolClickSimpleClass = "ToolClickSimpleNormal";
var custdivsimpleClass = "custdivsimpleNormal";
var residdivsimpleClass = "residdivsimpleNormal";
var CalRoomColRoomType = "CalRoomColRoomTypeNormal";
export default {
  data: function () {
    return {
      PlanData: {},
      Info: {},
      loginobject: actions.LoginGetResult(),
      schdResBasicsSimpleClass: "schdResBasicsSimpleNormal",
      ToolClickSimpleClass: "ToolClickSimpleNormal",
      custdivsimpleClass: "custdivsimpleNormal",
      residdivsimpleClass: "residdivsimpleNormal",
      CalRoomColRoomType: "CalRoomColRoomTypeNormal"
    };
  },
  methods: {
    openAlert: function () {
      var self = this;
      self.$app.dialog.alert("Hello World");
    },
    changePlanSize: async function (d) {
      var self = this;
      var loginobj = actions.LoginGetResult();
      var planSize = loginobj.SelectedPlanSize;
      var sizes = [25, 30, 35, 42, 50];
      var currentIndex = sizes.indexOf(planSize);
      $$('.plan-size-btn').removeClass("disabled-btn");

      if (currentIndex !== -1) {
        var newIndex = currentIndex + d;

        if (newIndex >= 0 && newIndex < sizes.length) {
          loginobj.SelectedPlanSize = sizes[newIndex];
          localStorage.setItem("loginJson", JSON.stringify(loginobj)); // Assuming these variables are defined somewhere

          var PlanDisplaySwitch = JSON.parse(localStorage.getItem('planDisplaySwitch'));
          var PlanUnassigned = JSON.parse(localStorage.getItem('planUnassigned'));
          var SelectedPlanSize = loginobj.SelectedPlanSize;
          var obj = {
            PropertyID: loginobj?.PropertyID,
            UserID: loginobj?.UserID,
            PlanDisplaySwitch: PlanDisplaySwitch,
            PlanUnassigned: PlanUnassigned,
            SelectedPlanSize: SelectedPlanSize
          };

          try {
            let response = await app.f7.request.promise.postJSON(URLS.SubmitPlanSettings, {
              obj
            }).then(res => {
              if (res.data == null) {
                var toastCheckConnection = app.f7.toast.create({
                  text: "Error,check internet connection",
                  position: "center",
                  closeTimeout: 1500
                }).open();
              }
            });
          } catch (error) {
            console.error("Error occurred while submitting plan settings:", error);
          }

          self.InitCalendar();
        }
      }

      if (planSize == 25) {
        $$('.minus-btn').addClass("disabled-btn");
      }

      if (planSize == 50) {
        $$('.plus-btn').addClass("disabled-btn");
      }
    },
    OMChangeViewFilter: function (view) {
      $("#OMViewOption1").removeClass("OMVOAct");
      $("#OMViewOption2").removeClass("OMVOAct");
      $("#OMViewOption3").removeClass("OMVOAct");

      if (view == 1) {
        $("#OMViewOption1").addClass("OMVOAct");
        $("#week_timeline_tab").click();
      } else if (view == 2) {
        $("#OMViewOption2").addClass("OMVOAct");
        $("#two_week_timeline_tab").click();
      } else if (view == 3) {
        $("#OMViewOption3").addClass("OMVOAct");
        $("#month_timeline_tab").click();
      }
    },
    GetRoomInfo: async function (RoomID) {},
    ToggleViewByRoomsType: function () {
      var ViewTR = $("#TLDropRooms").data("viewtype");

      if (ViewTR == 1) {
        $("#TLDropRooms").data("viewtype", "0");
        $("#TLDropRooms").html('By Type');
        FilterShowRoomCategories = 1;
      } else {
        $("#TLDropRooms").data("viewtype", "1");
        $("#TLDropRooms").html('By Rooms');
        FilterShowRoomCategories = 0;
      }

      this.updateFilters();
    },
    updateFilters: function () {
      try {
        var allRooms = scheduler.serverList("rooms");
        var visibleRooms;
        var FilteredTimes = 0;
        visibleRooms = allRooms.slice();
        var planUnassigned = JSON.parse(localStorage.getItem('planUnassigned'));
        var FilterByNestedRooms = 0;

        if (FilterShowRoomCategories == 0) {
          visibleRooms = visibleRooms.filter(function (room) {
            return room.type != "RoomCategory" && room.type != "StatsWaiting";
          });

          if (planUnassigned) {
            visibleRooms = visibleRooms.filter(function (room) {
              return room.type != "StatsWaiting" && room.type != "StatsWaitingTotal";
            });
          }

          if (FilterByNestedRooms == 1) {
            visibleRooms.sort(function (a, b) {
              var nameA = a.order,
                  nameB = b.order;
              if (nameA < nameB) //sort string ascending
                return -1;
              if (nameA > nameB) return 1;
              return 0; //default return value (no sorting)
            });
          } else {
            visibleRooms.sort(function (a, b) {
              var nameA = a.orderrooms,
                  nameB = b.orderrooms;
              if (nameA < nameB) //sort string ascending
                return -1;
              if (nameA > nameB) return 1;
              return 0; //default return value (no sorting)
            });
          }

          FilteredTimes++;
        } else {
          if (planUnassigned) {
            visibleRooms = visibleRooms.filter(function (room) {
              return room.type != "StatsWaiting" && room.type != "StatsWaitingTotal";
            });
          }

          visibleRooms.sort(function (a, b) {
            var nameA = a.order,
                nameB = b.order;
            if (nameA < nameB) //sort string ascending
              return -1;
            if (nameA > nameB) return 1;
            return 0; //default return value (no sorting)
          });
        }

        var FilterShowAvailableRooms = 0;

        if (FilterShowAvailableRooms == "0") {
          visibleRooms = visibleRooms.filter(function (room) {
            return room.type != "EventCalcRow";
          });
        }

        var FilterShowAvail = 0;

        if (FilterShowAvail == "0") {
          visibleRooms = visibleRooms.filter(function (room) {
            return room.type != "StatsAvailabilityTotal" && room.type != "StatsAvailabilityTotalBot";
          });
        }

        scheduler.updateCollection("visibleRooms", visibleRooms);
      } catch (err) {}
    },
    GetRoomAssignment: function (from, to, RoomCatID, B) {
      console.log(from, RoomCatID); //waiting list
    },
    GetUnassignedReservation: function (ReservationID) {
      console.log(ReservationID); //confirmed
    }
  },
  on: {
    tabInit: async function (e, page) {
      var planDisplaySwitch = JSON.parse(localStorage.getItem('planDisplaySwitch'));
      var planUnassigned = JSON.parse(localStorage.getItem('planUnassigned'));

      if (planDisplaySwitch) {
        $$("#TLDropRooms").click();
      }

      var self = this;

      try {
        clearInterval(window.RefreshOM);
      } catch (error) {}

      window.RefreshOM = setInterval(function () {
        CheckToRefreshOM();
      }, 5000);

      self.InitCalendar = function () {
        var loginobj = actions.LoginGetResult();
        var planSize = loginobj.SelectedPlanSize;
        var DisableMoveCheckedin = loginobj?.DisableMoveCheckedin;
        $$('.plan-size-btn').removeClass("disabled-btn");

        if (planSize == 25) {
          $$('.minus-btn').addClass("disabled-btn");
          schdResBasicsSimpleClass = "schdResBasicsSimpleMini";
          ToolClickSimpleClass = "ToolClickSimpleMini";
          custdivsimpleClass = "custdivsimpleMini";
          residdivsimpleClass = "residdivsimpleMini";
          CalRoomColRoomType = "CalRoomColRoomTypeMini";
        } else if (planSize == 30) {
          schdResBasicsSimpleClass = "schdResBasicsSimpleSmall";
          ToolClickSimpleClass = "ToolClickSimpleSmall";
          custdivsimpleClass = "custdivsimpleSmall";
          residdivsimpleClass = "residdivsimpleSmall";
          CalRoomColRoomType = "CalRoomColRoomTypeSmall";
        } else if (planSize == 35) {
          schdResBasicsSimpleClass = "schdResBasicsSimpleNormal";
          ToolClickSimpleClass = "ToolClickSimpleNormal";
          custdivsimpleClass = "custdivsimpleNormal";
          residdivsimpleClass = "residdivsimpleNormal";
          CalRoomColRoomType = "CalRoomColRoomTypeNormal";
        } else if (planSize == 42) {
          schdResBasicsSimpleClass = "schdResBasicsSimpleBig";
          ToolClickSimpleClass = "ToolClickSimpleBig";
          custdivsimpleClass = "custdivsimpleBig";
          residdivsimpleClass = "residdivsimpleBig";
          CalRoomColRoomType = "CalRoomColRoomTypeBig";
        } else if (planSize == 50) {
          $$('.plus-btn').addClass("disabled-btn");
          schdResBasicsSimpleClass = "schdResBasicsSimpleXL";
          ToolClickSimpleClass = "ToolClickSimpleXL";
          custdivsimpleClass = "custdivsimpleXL";
          residdivsimpleClass = "residdivsimpleXL";
          CalRoomColRoomType = "CalRoomColRoomTypeXL";
        }

        scheduler.attachEvent("onMouseMove", function (event_id, native_event) {
          var asd = scheduler.getActionData(native_event);
          var date = scheduler.getActionData(native_event).date;
          var section = scheduler.getActionData(native_event).section;
          var DateString = date.getDate() + "_" + (date.getMonth() + 1) + "_" + date.getFullYear();
          $(".dhxToMark").each(function () {
            $(this).css("background", "");
          });
          $(".dhxToMark").each(function () {
            $(this).css("background", "");
          });
          var DClass = "#dhxToMark_" + DateString;
          $(DClass).css("background", "#ffefd6");
          var RClass = "#dhxResToMark_" + section;
          $(RClass).css("background", "#ffefd6");
        });

        window.showRooms = function showRooms(type) {
          var allRooms = scheduler.serverList("rooms");
          var visibleRooms;

          if (type == 'all') {
            visibleRooms = allRooms; // .filter(function (room) {
            //     return room.type != "StatsWaitingTotal";
            // });
          } else {
            visibleRooms = allRooms.filter(function (room) {
              return room.type == type;
            });
          }

          if (planUnassigned) {
            visibleRooms = visibleRooms.filter(function (room) {
              return room.type != "StatsWaiting" && room.type != "StatsWaitingTotal";
            });
          }

          var FilterByNestedRooms = 0;

          if (FilterShowRoomCategories == 0) {
            visibleRooms = visibleRooms.filter(function (room) {
              return room.type != "RoomCategory" && room.type != "StatsWaiting";
            });

            if (FilterByNestedRooms == 1) {
              visibleRooms.sort(function (a, b) {
                var nameA = a.order,
                    nameB = b.order;
                if (nameA < nameB) //sort string ascending
                  return -1;
                if (nameA > nameB) return 1;
                return 0; //default return value (no sorting)
              });
            } else {
              visibleRooms.sort(function (a, b) {
                var nameA = a.orderrooms,
                    nameB = b.orderrooms;
                if (nameA < nameB) //sort string ascending
                  return -1;
                if (nameA > nameB) return 1;
                return 0; //default return value (no sorting)
              });
            }
          } else {
            visibleRooms.sort(function (a, b) {
              var nameA = a.order,
                  nameB = b.order;
              if (nameA < nameB) //sort string ascending
                return -1;
              if (nameA > nameB) return 1;
              return 0; //default return value (no sorting)
            });
          }

          var FilterShowAvailableRooms = 0;

          if (FilterShowAvailableRooms == "0") {
            visibleRooms = visibleRooms.filter(function (room) {
              return room.type != "EventCalcRow";
            });
          }

          var FilterShowAvail = 0;

          if (FilterShowAvail == "0") {
            visibleRooms = visibleRooms.filter(function (room) {
              return room.type != "StatsAvailabilityTotal" && room.type != "StatsAvailabilityTotalBot";
            });
          }

          scheduler.updateCollection("visibleRooms", visibleRooms);
        }; // //drag scroll
        // var schedulerContainer = document.getElementById("scheduler_here");
        // scheduler.attachEvent("onEventDrag", function (id, mode, e) {
        //     const schedulerContainer = document.getElementById("scheduler_here");
        //     const boundingRect = schedulerContainer.getBoundingClientRect();
        //     const margin = 50; // Distance to trigger scrolling
        //     const scrollSpeed = 10;
        //     let deltaX = 0, deltaY = 0;
        //     // Vertical Scrolling
        //     if (e.clientY - boundingRect.top < margin) {
        //         deltaY = -scrollSpeed;
        //     } else if (boundingRect.bottom - e.clientY < margin) {
        //         deltaY = scrollSpeed;
        //     }
        //     // Horizontal Scrolling
        //     if (e.clientX - boundingRect.left < margin) {
        //         deltaX = -scrollSpeed;
        //     } else if (boundingRect.right - e.clientX < margin) {
        //         deltaX = scrollSpeed;
        //     }
        //     // Perform scrolling and trigger rendering
        //     if (deltaX !== 0 || deltaY !== 0) {
        //         schedulerContainer.scrollBy(deltaX, deltaY);
        //         // Dynamically adjust visible range to load/render new parts
        //         const scrollLeft = schedulerContainer.scrollLeft;
        //         const scrollTop = schedulerContainer.scrollTop;
        //         // // Update rendering only for the newly scrolled area
        //         // scheduler.setCurrentView(null, null, {
        //         //     scroll_x: scrollLeft,
        //         //     scroll_y: scrollTop
        //         // });
        //     }
        // });


        scheduler.config.default_date = "%d-%m-%Y";
        scheduler.locale.labels.section_text = 'Name';
        scheduler.locale.labels.section_room = 'Room';
        scheduler.locale.labels.section_status = 'Status';
        scheduler.locale.labels.section_is_paid = 'Paid';
        scheduler.locale.labels.section_time = 'Time';
        scheduler.xy.nav_height = 45;
        scheduler.config.xml_date = "%Y-%m-%d %H:%i"; // step ana 12 wres

        scheduler.config.time_step = 1;
        scheduler.config.fix_tab_position = false;
        scheduler.xy.scale_height = 35;
        scheduler.config.limit_drag_out = false;
        scheduler.config.drag_resize = true;
        scheduler.config.mark_now = false;
        scheduler.setLoadMode("week");
        scheduler.config.prevent_cache = true;
        scheduler.config.show_loading = true; //===============
        //Configuration
        //===============

        scheduler.serverList("roomTypes");
        scheduler.serverList("roomStatuses");
        scheduler.serverList("bookingStatuses");
        scheduler.serverList("rooms");
        scheduler.locale.labels.week_timeline_tab = "WEEK";
        scheduler.locale.labels.two_week_timeline_tab = "2 WEEKS";
        scheduler.locale.labels.month_timeline_tab = "MONTH";
        scheduler.locale.labels.three_month_timeline_tab = "3 sMONTH"; // height of

        scheduler.xy.scale_height = 55;
        scheduler.createTimelineView({
          fit_events: true,
          name: "week_timeline",
          y_property: "room",
          render: "bar",
          x_unit: "day",
          x_date: " %j",
          x_step: 1,
          x_size: 7,
          //    x_size: 7+90,
          x_length: 7,
          dx: 180,
          dy: 36,
          event_dy: 30,
          section_autoheight: false,
          scrollable: true,
          column_width: 180,
          //  full_event__dy: true,
          y_unit: scheduler.serverList("visibleRooms")
        });
        scheduler.createTimelineView({
          fit_events: true,
          name: "two_week_timeline",
          y_property: "room",
          render: "bar",
          x_unit: "day",
          x_date: "%D %j",
          x_step: 1,
          x_size: 14,
          //  x_size: 14+90,
          x_length: 7,
          dx: 100,
          dy: 36,
          event_dy: 30,
          scrollable: true,
          column_width: 100,
          section_autoheight: false,
          full_event__dy: true,
          y_unit: scheduler.serverList("visibleRooms")
        });
        scheduler.createTimelineView({
          fit_events: true,
          name: "month_timeline",
          y_property: "room",
          render: "bar",
          x_unit: "day",
          x_date: "%D %j",
          x_step: 1,
          x_size: 14,
          x_length: 7,
          dx: 100,
          dy: 36,
          event_dy: 30,
          scrollable: true,
          column_width: 70,
          section_autoheight: false,
          full_event__dy: true,
          y_unit: scheduler.serverList("visibleRooms")
        });
        scheduler.createTimelineView({
          fit_events: true,
          name: "three_month_timeline",
          y_property: "room",
          render: "bar",
          x_unit: "day",
          x_date: "%D %j",
          x_step: 1,
          x_size: 60,
          x_length: 30,
          dx: 100,
          dy: 36,
          event_dy: 30,
          scrollable: true,
          column_width: 100,
          section_autoheight: false,
          full_event__dy: true,
          y_unit: scheduler.serverList("visibleRooms")
        });
        scheduler.createTimelineView({
          name: "timeline",
          x_unit: "day",
          x_date: "%j",
          x_step: 1,
          x_size: 31,
          //  x_size: 31+90,
          section_autoheight: false,
          y_unit: scheduler.serverList("visibleRooms"),
          y_property: "room",
          render: "bar",
          round_position: true,
          event_dy: "full",
          dy: 60,
          scrollable: true,
          column_width: 100,
          second_scale: {
            x_unit: "month",
            x_date: "%F, %Y"
          }
        });

        scheduler.date.week_timeline_start = scheduler.date.two_week_timeline_start = scheduler.date.month_timeline_start = scheduler.date.three_month_timeline_start = scheduler.date.week_start = function (date) {
          return this.date_part(this.add(date, 0, "day"));
        };

        if (!scheduler._onBeforeViewChange) {
          scheduler.attachEvent("onBeforeViewChange", function (old_mode, old_date, mode, date) {
            if (mode == "month_timeline") {
              var year = date.getFullYear();
              var month = date.getMonth() + 1;
              var d = new Date(year, month, 0);
              var days = d.getDate(); //numbers of day in month

              scheduler.matrix['month_timeline'].x_size = days;
              scheduler.matrix['month_timeline'].x_length = days;
            }

            if (old_mode != mode || +old_date != +date) scheduler.clearAll();
            return true;
          });
          scheduler._onBeforeViewChange = true;
        }

        if (!scheduler._onViewChange) {
          scheduler.attachEvent("onViewChange", function (new_mode, new_date) {
            var minDate = scheduler.getState().min_date;
            var maxDate = scheduler.getState().max_date;
            var minDateS = minDate.getDate() + "/" + (minDate.getMonth() + 1) + "/" + minDate.getFullYear();
            var maxDateS = maxDate.getDate() + "/" + (maxDate.getMonth() + 1) + "/" + maxDate.getFullYear();
            var day = minDate.getDate();
            var month = minDate.getMonth();
            var year = minDate.getFullYear();

            if (calendarRangeFrom2) {
              calendarRangeFrom2.setValue([new Date(year, month, day)]);
            } // var s = $("#dhx_cal_date").html();
            // if (s != null && s != "") {
            //     var Month = s.split('–');
            //     if (Month.length > 0) {
            //         var m1 = Month[0].trim(' ', '');
            //         if (Month.length > 1) {
            //             var m2 = Month[1].trim(' ', '');
            //             if (m1 == m2) {
            //                 $("#dhx_cal_date").html(m1)
            //             }
            //             else {
            //                 var temp = m1 + " – " + m2;;
            //                 $("#dhx_cal_date").html(temp)
            //             }
            //         }
            //     }
            // }

          });
          scheduler._onViewChange = true;
        }

        const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var weekDateFormat = scheduler.date.date_to_str("%D %j");

        scheduler.templates.week_timeline_scale_date = scheduler.templates.two_week_timeline_scale_date = function (date) {
          var today = new Date();
          today.setHours(0, 0, 0, 0);
          var temp = weekDateFormat(date);
          var day = temp.split(' ')[0];
          var num = temp.split(' ')[1];
          var Occupancy = '0';
          var DayClass = "";
          var Month = date.getMonth() + 1;
          var DateString = date.getDate() + "/" + Month + "/" + date.getFullYear();
          var DateString2 = date.getDate() + "_" + Month + "_" + date.getFullYear();
          var obj = "";

          if (date < today) {
            DayClass = "schDayNumberPrev";
          } else if (date > today) {} else {
            DayClass = "schDayNumberToday";
          }

          var DColorClass = "";
          var MonthName = monthNames[date.getMonth()];
          var WeekendClass = "";

          if (date.getDay() == 6 || date.getDay() == 0) {
            WeekendClass += "schWeekendMark";
          }

          var dhxToMark = "dhxToMark_" + DateString2;

          if (DayClass == "schDayNumberToday") {
            return "<div style='height:100%;display:flex;flex-direction:column;' class='dhxToMark dhxCustTodayHeader' id='" + dhxToMark + "'><span class='schMonthName'>" + MonthName + "</span><span class='schDayName " + DayClass + "'>" + day + "</span><span class='schDayNumberSm  " + DayClass + "'>" + num + "</span></div>";
          }

          return "<div style='height:100%;display:flex;flex-direction:column;' class='dhxToMark " + WeekendClass + "' id='" + dhxToMark + "'><span class='schMonthName'>" + MonthName + "</span><span class='schDayName " + DayClass + "'>" + day + "</span><span class='schDayNumberSm " + DayClass + "'>" + num + "</span></div>";
        };

        scheduler.templates.month_timeline_scale_date = scheduler.templates.three_month_timeline_scale_date = function (date) {
          var today = new Date();
          today.setHours(0, 0, 0, 0);
          var temp = weekDateFormat(date);
          var day = temp.split(' ')[0];
          var num = temp.split(' ')[1];
          var Occupancy = '0';
          var DayClass = "";
          var Month = date.getMonth() + 1;
          var DateString = date.getDate() + "/" + Month + "/" + date.getFullYear();
          var DateString2 = date.getDate() + "_" + Month + "_" + date.getFullYear();
          var obj = "";
          Occupancy = Occupancy + "%";
          var dhxToMark = "dhxToMark_" + DateString2;

          if (date < today) {
            DayClass = "schDayNumberPrev";
          } else if (date > today) {} else {
            DayClass = "schDayNumberToday";
          }

          var DColorClass = "";
          var MonthName = monthNames[date.getMonth()];
          var WeekendClass = "";

          if (date.getDay() == 6 || date.getDay() == 0) {
            WeekendClass += "schWeekendMark";
          }

          if (DayClass == "schDayNumberToday") {
            return "<div style='height:100%;display:flex;flex-direction:column;' class='dhxToMark dhxCustTodayHeader' id='" + dhxToMark + "'><span class='schMonthName'>" + MonthName + "</span><span class='schDayName " + DayClass + "'>" + day + "</span><span class='schDayNumberSm " + DayClass + "'>" + num + "</span></div>";
          }

          return "<div style='height:100%;display:flex;flex-direction:column;' class='dhxToMark " + WeekendClass + "' id='" + dhxToMark + "'><span class='schMonthName'>" + MonthName + "</span><span class='schDayName " + DayClass + "'>" + day + "</span><span class='schDayNumberSm " + DayClass + "'>" + num + "</span></div>";
        };

        scheduler.templates.week_timeline_scale_label = scheduler.templates.two_week_timeline_scale_label = scheduler.templates.month_timeline_scale_label = scheduler.templates.three_month_timeline_scale_label = function (key, label, section) {
          if (section.type == 'Room') {
            var PMSRoomIcon = "";

            if (section.PMSRoom == 1) {
              PMSRoomIcon = '<img title="This room will be available only on PMS (not available online)." class="CalPMSRoom" src="https://pms.abouthotelier.com/images/PMSRoom.png"</img>';
            }

            return `
                                <div onclick="GetRoomInfo(${key})" 
                                    oncontextmenu="GetRClickRoomInfo(${key}, 1, event)"
                                    class="dhxToMark dhxContextMenuRoom" 
                                    id="dhxResToMark_${key}"
                                    style="width:100%;cursor:pointer;" 
                                    data-room_cat="${section.RoomCategoryID}">
                                    <div class="CalendarRoomFloor">${section.Floor}</div>
                                    <div class="CalRoomColumn CustHorScroll" title="${section.RoomStatus} - ${section.RoomCategoryName}">
                                    <div class="CalendarRoomStatusIcon" style="background:#${section.ExtraColor}"></div>
                                    <span class="CalRoomColRoomNumber">${label}<span>${section.RoomGuestIcons}${PMSRoomIcon}</span></span>
                                    <span class="CalRoomColRoomType ${CalRoomColRoomType}">${section.RoomCategoryName}</span>${section.ExtraRoomsCats}
                                    </div>
                                </div>`;
          } else if (section.type == 'RoomCategory') {
            var temp = "(" + section.RoomCategoryID + ")";
            var iconclass = "fa-angle-down";

            try {
              if ($("#FilterShowRoomsByRoomCat").val().indexOf(temp) > -1) {
                iconclass = "fa-angle-up";
              }
            } catch (Err) {}

            return "<div style=\"width:100%\" class=\"dhxToMark\" id=\"dhxResToMark_" + key + "\">\
                                            <div onclick=\"updateRoomsShowByCategory(" + section.RoomCategoryID + ")\" class=\"CalRoomColumn SchdRoomCategory CustHorScroll\" title=\"" + section.Extra + " \">" + label + "<i  data-icon-room_cat=\"" + section.RoomCategoryID + "\" style=\"margin-left:3px\" class=\"fa " + iconclass + "\"></i></div></div>";
          } else if (section.type == 'PropertyRow') {
            var temp = "(" + section.PropertyID + ")";
            var iconclass = "fa-angle-down";

            try {
              if ($("#FilterShowRoomsByProperty").val().indexOf(temp) > -1) {
                iconclass = "fa-angle-up";
              }
            } catch (Err) {}

            return "<div style=\"width:100%\" class=\"dhxToMark\" id=\"dhxResToMark_" + key + "\">\
                                            <div onclick=\"updateRoomsShowByProperty(" + section.PropertyID + ")\" class=\"CalRoomColumn SchdPropertyRow CustHorScroll\" title=\"" + section.Extra + " \">" + label + "<i  data-icon-property=\"" + section.PropertyID + "\" style=\"margin-left:3px\" class=\"fa " + iconclass + "\"></i></div></div>";
          } else if (section.type == 'ApiKeyRow') {
            var ApiKeyID = section.ApiKeyID;

            if (section.PropertyID > 0) {
              ApiKeyID = section.PropertyID + "" + section.ApiKeyID;
            }

            var temp = "(" + ApiKeyID + ")";
            var iconclass = "fa-angle-down";

            try {
              if ($("#FilterShowRoomsByApiKey").val().indexOf(temp) > -1) {
                iconclass = "fa-angle-up";
              }
            } catch (Err) {}

            return "<div style=\"width:100%\" class=\"dhxToMark\" id=\"dhxResToMark_" + key + "\">\
                                            <div onclick=\"updateRoomsShowByApiKey(" + section.ApiKeyID + ")\" class=\"CalRoomColumn SchdApiKeyRow CustHorScroll\" title=\"" + section.Extra + " \">" + label + "<i  data-icon-apikey=\"" + section.ApiKeyID + "\" style=\"margin-left:3px\" class=\"fa " + iconclass + "\"></i></div></div>";
          } else if (section.type == 'StatsWaiting' || section.type == 'StatsWaitingTotal' || section.type == 'StatsWaitingTotalBot') {
            return "<div style=\"width:100%;\" class=\"dhxToMark\" id=\"dhxResToMark_" + key + "\">\
                                            <div class=\"CalRoomColumn SchdStatsWaiting\">Not Assigned</div></div>";
          } else if (section.type == 'StatsAvailabilityTotal' || section.type == 'StatsAvailabilityTotalBot') {
            return "<div style=\"width:100%;\" class=\"dhxToMark\" id=\"dhxResToMark_" + key + "\">\
                                            <div class=\"CalRoomColumn SchdStatsAvailabilityTotal\">Availability</div></div>";
          } else if (section.type == 'VirtualRoom') {
            return `
                                <div oncontextmenu="GetRClickRoomInfo(${section.VirtualRoomID}, 2, event)"
                                    class="dhxToMark dhxContextMenuRoom VirtualRoom VirtualRoomLS" 
                                    id="dhxResToMark_${key}"
                                    style="width:100%;cursor:pointer;" 
                                    data-room_cat="${section.RoomCategoryID}">
                                    <div class="CalendarRoomFloor" style="background-color: rgb(255, 255, 204) !important;"></div>
                                    <div class="CalRoomColumn" title="">
                                    <span class="CalRoomColRoomNumber">Help Row
                                        <div class="fa fa-info-circle btnHoverClickOp" onclick="GetHelpLineHelp();"></div>
                                    </span>
                                    <span class="CalRoomColRoomType ${CalRoomColRoomType}">${label} Room</span>
                                    </div>
                                </div>`;
          } else if (section.type == 'EventCalcRow' || section.type == 'EventCalcRowBot') {
            return "<div style=\"width:100%;\" class=\"dhxToMark\" id=\"dhxResToMark_" + key + "\">\
                                            <div class=\"CalRoomColumn SchdEventCalcRow\">Available Rooms</div></div>";
          }
        };

        function getShortDayName(date) {
          switch (date.getDay()) {
            case 0:
              return "Su";

            case 1:
              return "Mo";

            case 2:
              return "Tu";

            case 3:
              return "We";

            case 4:
              return "Th";

            case 5:
              return "Fr";

            case 6:
              return "Sa";

            default:
              return "";
          }
        }

        var get_formatted_duration = function (start, end) {
          var diff = end - start;
          var durations = {
            day: 24 * 60 * 60 * 1000,
            hour: 60 * 60 * 1000
          };
          var days = Math.floor(diff / durations.day);
          diff -= days * durations.day;
          var hours = Math.floor(diff / durations.hour);
          diff -= hours * durations.hour;
          var results = [];
          if (days) results.push(days + " days");
          if (hours) results.push(hours + " hours");
          return results.join(", ");
        };

        scheduler.templates.tooltip_date_format = scheduler.date.date_to_str("%j %M %Y");
        scheduler.addMarkedTimespan({
          days: [0, 6],
          zones: "fullday",
          css: "timeline_weekend"
        });
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        var todaynight = new Date();
        todaynight.setHours(23, 59, 59, 0);
        scheduler.addMarkedTimespan({
          start_date: today,
          end_date: todaynight,
          zones: "fullday",
          css: "timeline_today"
        });
        scheduler.config.lightbox.sections = [{
          map_to: "text",
          name: "text",
          type: "textarea",
          height: 24
        }, {
          map_to: "room",
          name: "room",
          type: "select",
          options: scheduler.serverList("visibleRooms")
        }, {
          map_to: "status",
          name: "status",
          type: "radio",
          options: scheduler.serverList("bookingStatuses")
        }, {
          map_to: "is_paid",
          name: "is_paid",
          type: "checkbox",
          checked_value: true,
          unchecked_value: false
        }, {
          map_to: "time",
          name: "time",
          type: "calendar_time"
        }];

        if (!scheduler._onEventCreated) {
          scheduler.attachEvent('onEventCreated', function (event_id) {
            var ev = scheduler.getEvent(event_id);
            ev.status = 1;
            ev.is_paid = false;
            ev.text = 'new booking';
            ev.ResID = 'New Reservation';
            ev.CustomerName = '';
            return false;
          });
          scheduler._onEventCreated = true;
        }

        if (!scheduler._onXLE) {
          scheduler.attachEvent("onXLE", function () {
            showRooms("all");
            var minDate = scheduler.getState().min_date;
            var maxDate = scheduler.getState().max_date;
            var minDateS = minDate.getDate() + "/" + (minDate.getMonth() + 1) + "/" + minDate.getFullYear();
            var maxDateS = maxDate.getDate() + "/" + (maxDate.getMonth() + 1) + "/" + maxDate.getFullYear();
            $("#ChkRefFromDate").val(minDateS);
            $("#ChkRefToDate").val(maxDateS);
            var ScrollTop = $("#HScrollSched_top").val();
            var ScrollLeft = $("#HScrollSched_left").val();

            if (ScrollTop > 0 || ScrollLeft > 0) {
              $("#HScrollSched_top").val(0);
              $("#HScrollSched_left").val(0);
              $(".dhx_timeline_data_wrapper").scrollTop(ScrollTop);
              $(".dhx_timeline_data_wrapper").scrollLeft(ScrollLeft); // native equivalent (x, y)
            }
          });
          scheduler._onXLE = true;
        }

        var element = document.getElementById("scheduler_here");

        if (!scheduler._onTemplatesReady) {
          scheduler.attachEvent("onTemplatesReady", function () {
            function findInArray(array, key) {
              for (var i = 0; i < array.length; i++) {
                if (key == array[i].key) return array[i];
              }

              return null;
            }

            function getRoomType(key) {
              return findInArray(scheduler.serverList("roomTypes"), key).label;
            }

            function getRoomStatus(key) {
              return findInArray(scheduler.serverList("roomStatuses"), key);
            }

            function getRoom(key) {
              return findInArray(scheduler.serverList("rooms"), key);
            }

            scheduler.templates.timeline_scale_label = function (key, label, section) {
              var roomStatus = getRoomStatus(section.status);
              return ["<div class='timeline_item_separator'></div>", "<div class='timeline_item_cell'>" + label + "</div>", "<div class='timeline_item_separator'></div>", "<div class='timeline_item_cell'>" + getRoomType(section.type) + "</div>", "<div class='timeline_item_separator'></div>", "<div class='timeline_item_cell room_status'>", "<span class='room_status_indicator room_status_indicator_" + section.status + "'></span>", "<span class='status-label'>" + roomStatus.label + "</span>", "</div>"].join("");
            };

            scheduler.templates.event_class = function (start, end, event) {
              return "event_" + (event.status || "") + " schType_" + event.IsType + " " + (event.IsVirtualClass || "") + " " + event.ExtraClass + " " + event.isAllot;
            }; //filtering data


            scheduler.filter_week_timeline = scheduler.filter_two_week_timeline = scheduler.filter_month_timeline = scheduler.filter_three_month_timeline = function (id, event) {
              var ShowCategories = $("#FilterShowRoomCategories").val(); // var ShowPrice = $("#FilterShowPrice").val();

              var ShowPrice = 0;

              if (ShowCategories == "1" || ShowPrice == "0") {
                if (event.IsType == 'CellPrice') return false; // event will be filtered (not rendered)
              }

              return true; // event will be rendered
            };

            var eventDateFormat = scheduler.date.date_to_str("%d %M %Y %H %i");
            var eventDateFormatAlt = scheduler.date.date_to_str("%d-%m-%Y");
            var eventDateFormatAlt3 = scheduler.date.date_to_str("%d/%m/%Y");

            scheduler.templates.event_bar_text = function (start, end, event) {
              var ShowAvail = 1;
              var ShowPrice = 0;
              var ShowCategories = 1;
              var ShowWaitingList = 1; // var startDate = eventDateFormat(event.start_date);
              // var endDate = eventDateFormat(event.end_date);

              var tempf = event.start_date.getMonth() + 1;
              var FromDate = event.start_date.getDate() + "/" + tempf + "/" + event.start_date.getFullYear();
              var tempt = event.end_date.getMonth() + 1; //  var ToDate = event.end_date.getDate() + "/" + tempt + "/" + event.end_date.getFullYear();
              //  var room = getRoom(event.room) || { label: "" };

              var tempDS = new Date(event.start_date.getFullYear(), event.start_date.getMonth(), event.start_date.getDate(), 0, 0, 0);
              var tempDE = new Date(event.end_date.getFullYear(), event.end_date.getMonth(), event.end_date.getDate(), 0, 0, 0);
              var nights = Math.floor((tempDE.getTime() - tempDS.getTime()) / 86400000);

              if (event.IsType == "RoomCategory") {
                return [''].join("");

                if (event.Availability == "STOP SALES") {
                  event.Availability = "SS";
                }

                var DifferentAvail = "";

                if (event.CheckAvailDifs == 1 && event.PMSAvailability != event.Availability && (event.PMSAvailability >= 0 || event.Availability > 0)) {
                  DifferentAvail = '<div class="AvailDifCal"><i class="fa fa-exclamation"></i></div>';
                }

                if (ShowAvail == "1") {
                  var AvailCClass = "OMNoAvail";

                  if (event.PMSAvailability > 0) {
                    AvailCClass = "OMAvail";
                  }

                  if (event.ShowOnlineAvail == '1') {
                    return ["<div class='SchdAvailPrice' style='height:100%'> <div class='SchdAvailPriceChild'>  <div class='booking_availability booking-option SchdAvailCell'><div class='" + AvailCClass + "'>" + event.PMSAvailability + " | " + event.Availability + "</div>" + DifferentAvail + "</div>", "</div></div>"].join("");
                  } else {
                    return ["<div class='SchdAvailPrice' style='height:100%'> <div class='SchdAvailPriceChild'>  <div class='booking_availability booking-option SchdAvailCell'><div class='" + AvailCClass + "'>" + event.PMSAvailability + "</div>" + DifferentAvail + "</div>", "</div></div>"].join("");
                  }
                } else if (ShowPrice == "1") {
                  return ["<div class='booking_avail_price booking-option SchdPriceCellSolo' style='text-align:center;width: 100%;height:100%'>" + "€" + event.Price + "</div>"].join("");
                } else if (ShowAvail == "1") {
                  if (event.ShowOnlineAvail == '1') {
                    return ["<div class='booking_availability booking-option SchdAvailCellSolo' style='text-align:center;width: 100%;height:100%'><div class='" + AvailCClass + "'>" + event.PMSAvailability + " | " + event.Availability + "</div>" + DifferentAvail + "</div>"].join("");
                  } else {
                    return ["<div class='booking_availability booking-option SchdAvailCellSolo' style='text-align:center;width: 100%;height:100%'><div class='" + AvailCClass + "'>" + event.PMSAvailability + "</div>" + DifferentAvail + "</div>"].join("");
                  }
                } else {
                  return ["<div class='booking_availability booking-option' style='text-align:center;width: 100%;height:100%'>" + "</div>"].join("");
                }
              } else if (event.IsType == "StatsWaiting") {
                if (event.Occupants == "0") {
                  // return ["<div class='booking_availability booking-option' style='text-align:center;width: 100%;' @click=\"GetRoomAssignment('" + FromDate + "'," + event.RoomCategoryID + ")\">0</div>"].join("");
                  return ["<div class='booking_availability booking-option' style='text-align:center;width: 100%;'>0</div>"].join("");
                } else {
                  // return ["<div class='booking_availability booking-option' style='text-align:center;width: 100%;' @click=\"GetRoomAssignment('" + FromDate + "'," + event.RoomCategoryID + ")\"><span class='schWaitRound'>" + event.Occupants + "</span></div>"].join("");
                  return ["<div class='booking_availability booking-option' style='text-align:center;width: 100%;'><span class='schWaitRound'>" + event.Occupants + "</span></div>"].join("");
                }
              } else if (event.IsType == "StatsWaitingTotal" || event.IsType == "StatsWaitingTotalBot") {
                if (event.Occupants == "0") {
                  // return ["<div class='booking_availability booking-option' style='text-align:center;width: 100%;' @click=\"GetRoomAssignment('" + FromDate + "'," + event.RoomCategoryID + ")\">0</div>"].join("");
                  return ["<div class='booking_availability booking-option' style='text-align:center;width: 100%;'>0</div>"].join("");
                } else {
                  // return ["<div class='booking_availability booking-option' style='text-align:center;width: 100%;' @click=\"GetRoomAssignment('" + FromDate + "'," + event.RoomCategoryID + ")\"><span class='schWaitRound'>" + event.Occupants + "</span></div>"].join("");
                  return ["<div class='booking_availability booking-option' style='text-align:center;width: 100%;'><span class='schWaitRound'>" + event.Occupants + "</span></div>"].join("");
                }
              } else if (event.IsType == "StatsAvailabilityTotal" || event.IsType == "StatsAvailabilityTotalBot") {
                return;
                var AvailCClass = "OMNoAvail";
                var InOccPerClass = "";
                var tempColOnA = "";
                var TempOnT = event.Availability;

                if (event.PMSAvailability > 0) {
                  AvailCClass = "OMAvail";

                  if (event.Availability == "STOP SALES") {
                    tempColOnA = "color:#DA6D6A;font-weight:600;";
                  }
                }

                if (event.OccupancyPercent >= 80) {
                  InOccPerClass = " InschOccH";
                } else if (event.OccupancyPercent >= 60) {
                  InOccPerClass = " InschOccM";
                }

                if (event.Availability == "STOP SALES") {
                  TempOnT = "SS";
                }

                var DifferentAvail = "";

                if (event.CheckAvailDifs == 1) {
                  DifferentAvail = '<div class="AvailDifCal"><i class="fa fa-exclamation"></i></div>';
                }

                var PmsAv = "<span>" + event.PMSAvailability + "</span>";
                var OnAv = "<span style='" + tempColOnA + "'>" + TempOnT + "</span>";

                if (event.ShowOnlineAvail == '1') {
                  return ["<div class='booking_availability booking-option SchdAvailCellSolo' style='text-align:center;width: 100%;height:100%;cursor:pointer;'><div class=\"InOccupancyPercent " + InOccPerClass + "\">" + event.OccupancyPercent + "%</div><div class='" + AvailCClass + "'>" + event.PMSAvailability + " | " + OnAv + "</div>" + DifferentAvail + "</div>"].join("");
                } else {
                  return ["<div class='booking_availability booking-option SchdAvailCellSolo' style='text-align:center;width: 100%;height:100%;cursor:pointer;'><div class=\"InOccupancyPercent " + InOccPerClass + "\">" + event.OccupancyPercent + "%</div><div class='" + AvailCClass + "'>" + event.PMSAvailability + "</div>" + DifferentAvail + "</div>"].join("");
                }
              } else if (event.IsType == "CellPrice") {
                if (ShowCategories == "0" && ShowPrice == "1") {
                  return ["<div class='booking_avail_price booking-option' style='text-align:center;width: 100%;'>" + event.Price + "</div>"].join("");
                } else return null;
              } else if (event.IsType == "OutOfOrder") {
                var OoOId = event.id.replace('OutOfOrder', '');
                return ["<div class='booking_availability booking-option SchdOutOfOrder' style='text-align:left;width: 100%; border: none; border-left: solid 5px #A6A6A6; padding-top: 8px; padding-left: 5px;' onclick=\"GetOutOfOrder(" + OoOId + ")\"><i class=\'fa fa-hand-paper-o\'></i>" + event.Details + "</div>"].join("");
              } else if (event.IsType == "BlockedDay") {
                var ExClass = "";
                var BlockText = "Blocked Dates";
                var paddingtop = "10px";

                if (event.IsBlockReserved == 1) {
                  ExClass = "SchdBlockedDayReserved";
                  BlockText = event.Title;
                  paddingtop = "6px;";
                }

                if (nights == 2) {
                  var BlockedDid = event.id.replace('BlockedDay', '');

                  if (event.GroupID > 0) {
                    return ["<div class='booking_availability booking-option SchdBlockedDay SchdBlockedDayGroup' style='text-align:left;width: 100%; border: none; border-left: solid 5px #A6A6A6; font-size: 11px !important; padding-top: 10px; padding-left: 5px;' onclick=\"OpenNewGroupReservation(" + event.GroupID + ",3,0)\"><i class=\'fa fa-hand-paper-o\'></i>" + " " + event.GroupName + "</div>"].join("");
                  } else if (event.AllotmentID > 0) {
                    return ["<div class='booking_availability booking-option SchdBlockedDay SchdBlockedDayAllotment' style='text-align:left;width: 100%; border: none; border-left: solid 5px #A6A6A6; font-size: 11px !important; padding-top: 10px; padding-left: 5px;'>" + '<i class=\'fa fa-briefcase\'></i> Block Allotment' + "</div>"].join("");
                  } else {
                    return ["<div class='booking_availability booking-option SchdBlockedDay " + ExClass + "' style='text-align:left;width: 100%; border: none; border-left: solid 5px #A6A6A6; padding-top:" + paddingtop + "; font-size: 11px !important; padding-left: 5px;'>" + '<i class=\'fa fa-hand-paper-o\'></i> ' + BlockText + "</div>"].join("");
                  }
                } else if (nights == 1 || nights < 1) {
                  var BlockedDid = event.id.replace('BlockedDay', '');

                  if (event.GroupID > 0) {
                    return ["<div class='booking_availability booking-option SchdBlockedDay SchdBlockedDayGroup' style='text-align:left;width: 100%; border: none; border-left: solid 5px #A6A6A6; font-size: 12px; padding-top: 8px; padding-left: 5px;' onclick=\"OpenNewGroupReservation(" + event.GroupID + ",3,0)\"><i class=\'fa fa-hand-paper-o\' style=\'margin-top: 1px; margin-bottom: 20px; margin-left: 5px;\'></i>" + "</div>"].join("");
                  } else if (event.AllotmentID > 0) {
                    return ["<div class='booking_availability booking-option SchdBlockedDay SchdBlockedDayAllotment' style='text-align:left;width: 100%; border: none; border-left: solid 5px #A6A6A6; font-size: 12px; padding-top: 8px; padding-left: 5px;'>" + '<i class=\'fa fa-briefcase\' style=\'margin-top: 1px; margin-bottom: 20px; margin-left: 5px;\'></i> ' + "</div>"].join("");
                  } else {
                    return ["<div class='booking_availability booking-option SchdBlockedDay " + ExClass + "' style='text-align:left;width: 100%; border: none; border-left: solid 5px #A6A6A6; padding-top: 8px; font-size: 12px; padding-left: 5px;'>" + '<i class=\'fa fa-hand-paper-o\' style=\'margin-top: 1px; margin-bottom: 20px; margin-left: 5px;\'></i> ' + "</div>"].join("");
                  }
                } else {
                  var BlockedDid = event.id.replace('BlockedDay', '');

                  if (event.GroupID > 0) {
                    return ["<div class='booking_availability booking-option SchdBlockedDay SchdBlockedDayGroup' style='text-align:left;width: 100%; border: none; border-left: solid 5px #A6A6A6; padding-top: 10px; font-size: 12px !important; padding-left: 5px;' onclick=\"OpenNewGroupReservation(" + event.GroupID + ",3,0)\"><i class=\'fa fa-hand-paper-o\'></i>" + " " + event.GroupName + "</div>"].join("");
                  } else if (event.AllotmentID > 0) {
                    return ["<div class='booking_availability booking-option SchdBlockedDay SchdBlockedDayAllotment' style='text-align:left;width: 100%; border: none; border-left: solid 5px #A6A6A6; padding-top: 10px; font-size: 12px !important; padding-left: 5px;'>" + '<i class=\'fa fa-briefcase\'></i> Block Allotment' + "</div>"].join("");
                  } else {
                    return ["<div class='booking_availability booking-option SchdBlockedDay " + ExClass + "' style='text-align:left;width: 100%; border: none; border-left: solid 5px #A6A6A6; padding-top: 10px; font-size: 12px !important; padding-left: 5px;'>" + '<i class=\'fa fa-hand-paper-o\'></i> ' + BlockText + "</div>"].join("");
                  }
                }
              } else if (event.IsType == "BlockedDayVR") {
                var BlockedDid = event.id.replace('BlockedDay', '');

                if (nights == 2) {
                  return ["<div class='booking_availability booking-option SchdBlockedDay' style='text-align:left;width: 100%; border: none; border-left: solid 5px #A6A6A6; padding-top:10px; font-size: 11px !important; padding-left: 5px;'>" + '<i class=\'fa fa-hand-paper-o\'></i> Blocked Dates' + "</div>"].join("");
                } else if (nights == 1 || nights < 1) {
                  return ["<div class='booking_availability booking-option SchdBlockedDay' style='text-align:left;width: 100%; border: none; border-left: solid 5px #A6A6A6; padding-top: 8px; font-size: 12px; padding-left: 5px;'>" + '<i class=\'fa fa-hand-paper-o\' style=\'margin-top: 1px; margin-bottom: 20px; margin-left: 5px;\'></i> ' + "</div>"].join("");
                } else {
                  return ["<div class='booking_availability booking-option SchdBlockedDay' style='text-align:left;width: 100%; border: none; border-left: solid 5px #A6A6A6; padding-top: 10px; font-size: 12px !important; padding-left: 5px;'>" + '<i class=\'fa fa-hand-paper-o\'></i> Blocked Dates' + "</div>"].join("");
                }
              } else if (event.IsType == "MoveDupe") {
                return ["<div class='schdResBasics'></div><br />"].join("");
              } else if (event.IsType == "ToFillRR" || event.IsType == "ToFillRRVR") {
                var BlockedDid = event.id.replace('ToFillRR', '');
                return ["<div class='booking_availability booking-option SchdBlockedDay ToFillE' @click=\"GetUnassignedReservation(" + BlockedDid + ")\">" + '<i class=\'fa fa-bookmark\'></i><span class=\'\'> Confirmed Reservation' + "</span></div>"].join("");
              } else {
                var elt = ".CStooltip_" + event.ReservationID;
                $(elt).hide();

                if (event.IsType == null) {
                  return ["<div class='schdResBasics' style='text-align:left;height:100%;background:inherit;position:relative;'><span style='position:absolute;top:0px;line-height:29px;font-size: 11px;'>" + nights + " Nights</span></div>"].join("");
                }

                var occupants = event.Adults;

                if (event.Children != "" && event.Children != 0) {
                  occupants += "+" + event.Children;
                }

                var PriceInfo = loginobject?.IsHousekeeper ? "<span style='margin-left:5px'>" + event.PriceTr + "€" + "</span>" : "";

                if (event.IsSplitted == "1") {
                  if (event.isAllot == "AllotmentCL") {
                    if (SimpleEventStyle == 1) {
                      if (event.SplitMoveFirstPart == "0") {
                        return ["<div class='" + schdResBasicsSimpleClass + " schdRBFJS'><div class='" + ToolClickSimpleClass + "'><i class='" + event.source_icon + "'></i></div> <div style='display: flex;flex-direction: column;'> <div class='" + custdivsimpleClass + "'>" + event.CustomerName + "</div>", "<div class='" + residdivsimpleClass + "'>" + event.OnlineResCode + "</div></div><i class='undefined' style='color: black; float: right;'></i><i class='undefined' style='color: black; float: right;'></i></div> <div style='color:#fff;' class='booking_splitroomE booking-option'> <span style='font-size:14px'>»</span></div></div>"].join("");
                      } else if (event.SplitMoveFirstPart == "1") {
                        return ["<div class='" + schdResBasicsSimpleClass + " schdRBFJS'><div class='" + ToolClickSimpleClass + "'><i class='" + event.source_icon + "'></i></div> <div style='display: flex;flex-direction: column;'> <div class='" + custdivsimpleClass + "'>" + event.CustomerName + "</div>", "<div class='" + residdivsimpleClass + "'>" + event.OnlineResCode + "</div></div><i class='undefined' style='color: black; float: right;'></i><i class='undefined' style='color: black; float: right;'></i></div> <div style='color:#fff;' class='booking_splitroomS booking-option'> <span style='font-size:14px'>»</span></div></div>"].join("");
                      } else if (event.SplitMoveFirstPart == "2") {
                        return ["<div class='" + schdResBasicsSimpleClass + " schdRBFJS'><div class='" + ToolClickSimpleClass + "'><i class='" + event.source_icon + "'></i></div> <div style='display: flex;flex-direction: column;'> <div class='" + custdivsimpleClass + "'>" + event.CustomerName + "</div>", "<div class='" + residdivsimpleClass + "'>" + event.OnlineResCode + "</div></div><i class='undefined' style='color: black; float: right;'></i><i class='undefined' style='color: black; float: right;'></i></div><div style='color:#fff;' class='booking_splitroomS booking-option'><span style='font-size:14px'>»</span></div> <div style='color:#fff;' class='booking_splitroomE booking-option'> <span style='font-size:14px'>»</span></div></div>"].join("");
                      }
                    } else {
                      if (event.SplitMoveFirstPart == "0") {
                        return ["<div class='schdResBasics' style='background:inherit'>" + event.CustomerName + "<div class='shdHideLDrag'></div></div>", "<div class='schdResIcons'><i class='fa fa-user-times'><span class='TimesISpan'>" + occupants + "</span></i><span style='margin-left:5px;' title='" + event.board_title + "' class='" + event.board_class + "'>" + event.board_code + "</span><i class='" + event.comp_icon + "'></i><i style='" + event.trav_icon_style + "' class='" + event.trav_icon + "'></i><i class='" + event.transfer_icon + "'></i><span style='margin-left:5px'><i style='font-size: 10px; position: relative; top: -2px;' class='" + event.notes_icon + "'></i></span>" + PriceInfo + "<i style='margin-left:5px;' class='" + event.paid_icon + "'></i>" + event.paytype_icons + "<div style='color:#fff;' class='booking_splitroomE booking-option'><span style='font-size:14px'>»</span></div></div>"].join("");
                      } else if (event.SplitMoveFirstPart == "1") {
                        return ["<div class='schdResBasics'>" + event.CustomerName + "</div>", "<div class='schdResIcons'><i class='fa fa-user-times'><span class='TimesISpan'>" + occupants + "</span></i><span style='margin-left:5px;' title='" + event.board_title + "' class='" + event.board_class + "'>" + event.board_code + "</span><i class='" + event.comp_icon + "'></i><i style='" + event.trav_icon_style + "' class='" + event.trav_icon + "'></i><i class='" + event.transfer_icon + "'></i><span style='margin-left:5px'><i style='font-size: 10px; position: relative; top: -2px;' class='" + event.notes_icon + "'></i></span>" + PriceInfo + "<i style='margin-left:5px;' class='" + event.paid_icon + "'></i>" + event.paytype_icons + "<div style='color:#fff;' class='booking_splitroomS booking-option'><span style='font-size:14px'>»</span></div></div>"].join("");
                      } else if (event.SplitMoveFirstPart == "2") {
                        return ["<div class='schdResBasics'>" + event.CustomerName + "</div>", "<div class='schdResIcons'><i class='fa fa-user-times'><span class='TimesISpan'>" + occupants + "</span></i><span style='margin-left:5px;' title='" + event.board_title + "' class='" + event.board_class + "'>" + event.board_code + "</span><i class='" + event.comp_icon + "'></i><i style='" + event.trav_icon_style + "' class='" + event.trav_icon + "'></i><i class='" + event.transfer_icon + "'></i><span style='margin-left:5px'><i style='font-size: 10px; position: relative; top: -2px;' class='" + event.notes_icon + "'></i></span>" + PriceInfo + "<i style='margin-left:5px;' class='" + event.paid_icon + "'></i>" + event.paytype_icons + "<div style='color:#fff;' class='booking_splitroomS booking-option'><span style='font-size:14px'>»</span></div><div class='booking_splitroomE booking-option'><span style='font-size:14px'>»</span></div></div>"].join("");
                      }
                    }
                  } else {
                    if (SimpleEventStyle == 1) {
                      if (event.SplitMoveFirstPart == "0") {
                        return ["<div class='" + schdResBasicsSimpleClass + " schdRBFJS'><div class='" + ToolClickSimpleClass + "'><i class='" + event.source_icon + "'></i></div> <div style='display: flex;flex-direction: column;'> <div class='" + custdivsimpleClass + "'>" + event.CustomerName + "</div>", "<div class='" + residdivsimpleClass + "'>" + event.OnlineResCode + "</div></div><i class='undefined' style='color: black; float: right;'></i><i class='undefined' style='color: black; float: right;'></i><div style='color:#fff;' class='booking_splitroomE booking-option'><span style='font-size:14px'>»</span></div></div>"].join("");
                      } else if (event.SplitMoveFirstPart == "1") {
                        return ["<div class='" + schdResBasicsSimpleClass + " schdRBFJS'><div class='" + ToolClickSimpleClass + "'><i class='" + event.source_icon + "'></i></div> <div style='display: flex;flex-direction: column;'> <div class='" + custdivsimpleClass + "'>" + event.CustomerName + "</div>", "<div class='" + residdivsimpleClass + "'>" + event.OnlineResCode + "</div></div><i class='undefined' style='color: black; float: right;'></i><i class='undefined' style='color: black; float: right;'></i><div style='color:#fff;' class='booking_splitroomS booking-option'><span style='font-size:14px'>»</span></div></div>"].join("");
                      } else if (event.SplitMoveFirstPart == "2") {
                        return ["<div class='" + schdResBasicsSimpleClass + " schdRBFJS'><div class='" + ToolClickSimpleClass + "'><i class='" + event.source_icon + "'></i></div> <div style='display: flex;flex-direction: column;'> <div class='" + custdivsimpleClass + "'>" + event.CustomerName + "</div>", "<div class='" + residdivsimpleClass + "'>" + event.OnlineResCode + "</div></div><i class='undefined' style='color: black; float: right;'></i><i class='undefined' style='color: black; float: right;'></i><div style='color:#fff;' class='booking_splitroomS booking-option'><span style='font-size:14px'>»</span></div><div class='booking_splitroomE booking-option'><span style='font-size:14px'>»</span></div></div>"].join("");
                      }
                    } else {
                      if (event.SplitMoveFirstPart == "0") {
                        return ["<div class='schdResBasics' style='background:inherit'>" + event.CustomerName + "<div class='shdHideLDrag'></div></div>", "<div class='schdResIcons'><div class='ToolClick'><i class='" + event.source_icon + "'></i></div><i class='fa fa-user-times'><span class='TimesISpan'>" + occupants + "</span></i><span style='margin-left:5px;' title='" + event.board_title + "' class='" + event.board_class + "'>" + event.board_code + "</span><i class='" + event.comp_icon + "'></i><i style='" + event.trav_icon_style + "' class='" + event.trav_icon + "'></i><i class='" + event.transfer_icon + "'></i><span style='margin-left:5px'><i style='font-size: 10px; position: relative; top: -2px;' class='" + event.notes_icon + "'></i></span>" + PriceInfo + "<i style='margin-left:5px;' class='" + event.paid_icon + "'></i>" + event.paytype_icons + "<div class='booking_splitroomE booking-option'><span style='font-size:14px'>»</span></div><div class='StrokeColTop' id='StrokeColTop_" + event.ReservationID + "' style='background:" + event.ResColor + "'></div><div class='StrokeColBot' style='background:" + event.SourceColor + "'></div></div>"].join("");
                      } else if (event.SplitMoveFirstPart == "1") {
                        return ["<div class='schdResBasics'>" + event.CustomerName + "</div>", "<div class='schdResIcons'><div class='ToolClick'><i class='" + event.source_icon + "'></i></div><i class='fa fa-user-times'><span class='TimesISpan'>" + occupants + "</span></i><span style='margin-left:5px;' title='" + event.board_title + "' class='" + event.board_class + "'>" + event.board_code + "</span><i class='" + event.comp_icon + "'></i><i style='" + event.trav_icon_style + "' class='" + event.trav_icon + "'></i><i class='" + event.transfer_icon + "'></i><span style='margin-left:5px'><i style='font-size: 10px; position: relative; top: -2px;' class='" + event.notes_icon + "'></i></span>" + PriceInfo + "<i style='margin-left:5px;' class='" + event.paid_icon + "'></i>" + event.paytype_icons + "<div class='booking_splitroomS booking-option'><span style='font-size:14px'>»</span></div><div class='StrokeColTop' id='StrokeColTop_" + event.ReservationID + "' style='background:" + event.ResColor + "'></div><div class='StrokeColBot' style='background:" + event.SourceColor + "'></div></div>"].join("");
                      } else if (event.SplitMoveFirstPart == "2") {
                        return ["<div class='schdResBasics'>" + event.CustomerName + "</div>", "<div class='schdResIcons'><div class='ToolClick'><i class='" + event.source_icon + "'></i></div><i class='fa fa-user-times'><span class='TimesISpan'>" + occupants + "</span></i><span style='margin-left:5px;' title='" + event.board_title + "' class='" + event.board_class + "'>" + event.board_code + "</span><i class='" + event.comp_icon + "'></i><i style='" + event.trav_icon_style + "' class='" + event.trav_icon + "'></i><i class='" + event.transfer_icon + "'></i><span style='margin-left:5px'><i style='font-size: 10px; position: relative; top: -2px;' class='" + event.notes_icon + "'></i></span>" + PriceInfo + "<i style='margin-left:5px;' class='" + event.paid_icon + "'></i>" + event.paytype_icons + "<div class='booking_splitroomS booking-option'><span style='font-size:14px'>»</span></div><div class='booking_splitroomE booking-option'><span style='font-size:14px'>»</span></div><div class='StrokeColTop' id='StrokeColTop_" + event.ReservationID + "' style='background:" + event.ResColor + "'></div><div class='StrokeColBot' style='background:" + event.SourceColor + "'></div></div>"].join("");
                      }
                    }
                  }
                } else {
                  if (event.isAllot == "AllotmentCL") {
                    if (SimpleEventStyle == 1) {
                      return ["<div class='" + schdResBasicsSimpleClass + " schdRBFJS'><div class='" + ToolClickSimpleClass + "'><i class='" + event.source_icon + "'></i></div> <div style='display: flex;flex-direction: column;'> <div class='" + custdivsimpleClass + "'>" + event.CustomerName + "</div>", "<div class='" + residdivsimpleClass + "'>" + event.OnlineResCode + "</div></div><i class='undefined' style='color: black; float: right;'></i><i class='undefined' style='color: black; float: right;'></i></div>"].join("");
                    } else {
                      return ["<div class='schdResBasics'>" + event.CustomerName + "</div>", "<div class='schdResIcons'><i class='fa fa-user-times'><span class='TimesISpan'>" + occupants + "</span></i><span style='margin-left:5px;' title='" + event.board_title + "' class='" + event.board_class + "'>" + event.board_code + "</span><i class='" + event.comp_icon + "'></i><i style='" + event.trav_icon_style + "' class='" + event.trav_icon + "'></i><i class='" + event.transfer_icon + "'></i><span style='margin-left:5px'><i style='font-size: 10px; position: relative; top: -2px;' class='" + event.notes_icon + "'></i></span>" + PriceInfo + "<i style='margin-left:5px;' class='" + event.paid_icon + "'></i>" + event.paytype_icons + "<i style='margin-left:5px;' class='" + event.has_transfer_icon + "'></i></div>"].join("");
                    }
                  } else {
                    if (SimpleEventStyle == 1) {
                      //edw plan div
                      return ["<div class='" + schdResBasicsSimpleClass + " schdRBFJS'><div class='" + ToolClickSimpleClass + "'><i class='" + event.source_icon + "'></i></div> <div style='display: flex;flex-direction: column;'> <div class='" + custdivsimpleClass + "'>" + event.CustomerName + "</div>", "<div class='StrokeColTop StrokeColTop2' id='StrokeColTop2_" + event.ReservationID + "' style='background:" + event.CheckinColor + "'></div><div class='StrokeColBot' style='background:" + event.SourceColor + ";" + "height:4px;" + "z-index:-1;" + "'></div>" + "<div class='" + residdivsimpleClass + "'>" + event.OnlineResCode + "</div></div><i class='undefined' style='color: black; float: right;'></i><i class='undefined' style='color: black; float: right;'></i></div>"].join("");
                    } else {
                      return ["<div class='schdResBasics'>" + event.CustomerName + "</div>", "<div class='schdResIcons'><div class='ToolClick'><i class='" + event.source_icon + "'></i></div><i class='fa fa-user-times'><span class='TimesISpan'>" + occupants + "</span></i><span style='margin-left:5px;' title='" + event.board_title + "' class='" + event.board_class + "'>" + event.board_code + "</span><i class='" + event.comp_icon + "'></i><i style='" + event.trav_icon_style + "' class='" + event.trav_icon + "'></i><i class='" + event.transfer_icon + "'></i><span style='margin-left:5px'><i style='font-size: 10px; position: relative; top: -2px;' class='" + event.notes_icon + "'></i></span>" + PriceInfo + "<i style='margin-left:5px;' class='" + event.paid_icon + "'></i>" + event.paytype_icons + "<i style='margin-left:5px;' class='" + event.has_transfer_icon + "'></i><div class='StrokeColTop' id='StrokeColTop_" + event.ReservationID + "' style='background: " + event.ResColor + "'></div><div class='StrokeColBot' style='background: " + event.SourceColor + "'></div></div>"].join("");
                    }
                  }
                }
              }
            };

            scheduler.templates.tooltip_text = function (start, end, event) {
              return; // var room = getRoom(event.room) || { label: "" };

              var html = [];

              if ($("#contextMenu").is(":visible")) {
                return false;
              }

              if (event.IsType == "RoomCategory") {
                html.push("<div style='padding:0px 40px 15px 40px;margin-top: -8px;'>");
                html.push("<span class='tooltipBHeader'>" + 'PMS Avail.' + ":</span> <span class='tooltipBText'>" + event.PMSAvailability + "</span>");

                if (event.ShowOnlineAvail == '1' || event.HasOnlineAvail == '1') {
                  html.push("<span class='tooltipBHeader'>" + 'Base Avail.' + ":</span> <span class='tooltipBText'>" + event.Availability + "</span>");
                }

                if (event.Price != "N/A") {
                  html.push("<span class='tooltipBHeader'>" + 'Price' + ":</span> <span class='tooltipBText'>" + event.Price + "€" + " </span>");
                }

                html.push("</div>");
              } else if (event.IsType == "StatsWaiting") {} else if (event.IsType == "StatsWaitingTotal" || event.IsType == "StatsWaitingTotalBot") {} else if (event.IsType == "StatsAvailabilityTotal" || event.IsType == "StatsAvailabilityTotalBot") {
                var SSstyles = "font-size: 24px;line-height: 35px;";
                var ta = event.Availability;
                var OnTotAvail = "/" + event.TotalAvailRooms;

                if (event.Availability == "STOP SALES") {
                  SSstyles = "font-size:12px;line-height:12px;color:#DA6D6A;margin-top:4px;";
                  ta = "STOP<br/>SALES";
                }

                if (event.ShowOnlineAvail == '1' || event.HasOnlineAvail == '1') {
                  html.push("<div class='AVTooltipTable ' style='width:300px;'>");
                  html.push("<div class='AVTooltipRow' style='border-bottom:1px solid #dcdcdc;font-weight: 600;'><div class='AVTooltipCat'>" + eventDateFormatAlt3(start) + "</div><div class='AVTooltipAv'>" + 'PMS Avail' + "</div><div class='AVTooltipAvO'>" + 'Base Avail' + "</div></div>");
                  html.push("<div class='AVTooltipRow' style='border-bottom:1px solid #dcdcdc;'><div class='AVTooltipCat'>" + 'Total' + "</div><div class='AVTooltipAv' style='font-size: 24px;line-height: 35px;font-weight: 900;'>" + event.PMSAvailability + "/" + event.TotalAvailRooms + "</div><div class='AVTooltipAvO' style='font-weight: 900;" + SSstyles + "'>" + ta + OnTotAvail + "</div></div>");
                } else {
                  html.push("<div class='AVTooltipTable ' style='width:210px;'>");
                  html.push("<div class='AVTooltipRow'><div class='AVTooltipCat'>" + eventDateFormatAlt3(start) + "</div><div class='AVTooltipAv'>" + 'PMS Avail' + "</div></div>");
                  html.push("<div class='AVTooltipRow'><div class='AVTooltipCat'>" + 'Total' + "</div><div class='AVTooltipAv' style='font-size: 24px;line-height: 35px;font-weight: 900;'>" + event.PMSAvailability + "/" + event.TotalAvailRooms + "</div></div>");
                }

                if (event.AvailInfo != null && event.AvailInfo != "") {
                  var avails = event.AvailInfo.split("*.*");

                  for (var i = 0; i < avails.length; i++) {
                    if (avails[i] != "") {
                      var availsplits = avails[i].split("-_-");
                      var tempav = availsplits[1];
                      var tempavcl = "background:#DA6D6A";

                      if (tempav > 0) {
                        tempavcl = "background:#72B39F";
                      }

                      var OIsStopSales = availsplits[3];
                      var Otempav = availsplits[2];
                      var TotalAvRooms = availsplits[4];
                      var Otempavcl = "background:#DA6D6A";

                      if (Otempav > 0 && OIsStopSales == 0) {
                        Otempavcl = "background:#72B39F";
                      }

                      if (event.ShowOnlineAvail == '1' || event.HasOnlineAvail == '1') {
                        html.push("<div class='AVTooltipRow'><div class='AVTooltipCat'>" + availsplits[0] + "</div><div class='AVTooltipAv'><div class='AVTooltipAvNum' style='" + tempavcl + "'>" + tempav + "/" + TotalAvRooms + "</div></div><div class='AVTooltipAvO'><div class='AVTooltipAvNum' style='" + Otempavcl + "'>" + Otempav + "/" + TotalAvRooms + "</div></div></div>");
                      } else {
                        html.push("<div class='AVTooltipRow'><div class='AVTooltipCat'>" + availsplits[0] + "</div><div class='AVTooltipAv'><div class='AVTooltipAvNum' style='" + tempavcl + "'>" + tempav + "/" + TotalAvRooms + "</div></div></div>");
                      }
                    }
                  }
                }

                html.push("</div>");
                return html.join("");
              } else if (event.IsType == "CellPrice") {} else if (event.IsType == "MoveDupe") {} else if (event.IsType == "OutOfOrder") {
                html.push("<div style='padding:0px 40px 15px 40px;margin-top: -8px;'>");
                html.push("<span class='tooltipBHeader'>" + 'Out Of Order Comment' + ":</span> <span>" + event.Details + "</span>");
                html.push("<span class='tooltipBHeader'>" + 'From' + ":</span> <span>" + eventDateFormatAlt3(start) + "</span>");
                html.push("<span class='tooltipBHeader'>" + 'To' + ":</span> <span>" + eventDateFormatAlt3(end) + "</span>");
                html.push("</div>");
              } else if (event.IsType == "BlockedDay" || event.IsType == "BlockedDayVR") {
                html.push("<div style='padding:0px 40px 15px 40px;margin-top: -8px;'>");
                html.push("<span class='tooltipBHeader'>" + 'Title' + ":</span> <span>" + event.Title + "</span>");
                html.push("<span class='tooltipBHeader'>" + 'Room' + ":</span> <span>" + event.text + "</span>");
                html.push("<span class='tooltipBHeader'>" + 'Comment' + ":</span> <span>" + event.Details + "</span>");
                html.push("<span class='tooltipBHeader'>" + 'From' + ":</span> <span>" + eventDateFormatAlt3(start) + "</span>");
                html.push("<span class='tooltipBHeader'>" + 'To' + ":</span> <span>" + eventDateFormatAlt3(end) + "</span>");
                html.push("</div>");
              } else if (event.IsType == "Reservation") {} //AddDelayedClassToEl();


              return html.join("<br>");
            }; // τίτλος του modal


            scheduler.templates.lightbox_header = function (start, end, ev) {
              var formatFunc = scheduler.date.date_to_str('%d.%m.%Y %H:%i');
              return formatFunc(start) + " - " + formatFunc(end);
            };
          });
          scheduler._onTemplatesReady = true;
        }

        if (CheckALEL == 0) {
          if (!scheduler._onEventCollision) {
            scheduler.attachEvent("onEventCollision", function (ev, evs) {
              $("#ReservationIDsBlocks").val('');
              var BlockedDayIDs = "";
              var IsBlocked = false; //if (ev.IsType != "Reservation") {

              var BlockedResIDs = "";
              var BlocksTotal = 0;
              var BlocksRes = 0;

              for (var i = 0; i < evs.length; i++) {
                if (evs[i].IsType != "Reservation") {
                  // if event type equals CellPrice then destroy
                  // Callback to delete entire column here and in success handler:
                  if (ev.room == evs[i].room && evs[i].IsType == "CellPrice") {
                    scheduler._select_id = null; //delete scheduler._events[evs[i].id];

                    continue;
                  }

                  if (ev.room == evs[i].room && evs[i].IsType == "BlockedDayVR") {
                    scheduler.deleteEvent(evs[i].id);
                    BlockedDayIDs += evs[i].id.replace("BlockedDay", "") + ",";
                    continue;
                  }

                  if (ev.room == evs[i].room && evs[i].IsType == "OutOfOrder") {
                    BlocksTotal++;
                    IsBlocked = true;
                    app.f7.toast.create({
                      text: 'Error',
                      closeButton: true,
                      closeButtonText: 'This room is out of order',
                      closeButtonColor: 'red'
                    }).open();
                  }

                  if (ev.room == evs[i].room && evs[i].IsType == "BlockedDay") {
                    BlocksTotal++;
                    IsBlocked = true;
                    app.f7.toast.create({
                      text: 'Error',
                      closeButton: true,
                      closeButtonText: 'Blocked Day',
                      closeButtonColor: 'red'
                    }).open();
                  }

                  if (ev.room == evs[i].room && evs[i].IsType == "ToFillRR") {
                    BlocksTotal++;
                    IsBlocked = true;
                  }
                } else {
                  // check if same room
                  if (ev.room != evs[i].room) {
                    continue;
                  }

                  var startDateN = ev.start_date;
                  IsBlocked = true;
                  var Otempf = ev.start_date.getMonth() + 1;
                  var Otempt = ev.end_date.getMonth() + 1;
                  var Ofrom = ev.start_date.getDate() + "/" + Otempf + "/" + ev.start_date.getFullYear();
                  var Oto = ev.end_date.getDate() + "/" + Otempt + "/" + ev.end_date.getFullYear();
                  var Ntempf = evs[i].start_date.getMonth() + 1;
                  var Ntempt = evs[i].end_date.getMonth() + 1;
                  var Nfrom = evs[i].start_date.getDate() + "/" + Ntempf + "/" + evs[i].start_date.getFullYear();
                  var Nto = evs[i].end_date.getDate() + "/" + Ntempt + "/" + evs[i].end_date.getFullYear();

                  if (Ofrom == Nfrom && Oto == Nto) {
                    BlocksTotal++;
                    BlocksRes++;
                    BlockedResIDs += "," + evs[i].ReservationID;
                  }
                }
              }

              if (ev.IsType == "Reservation" && BlocksRes == BlocksTotal && BlockedResIDs != "") {
                BlockedResIDs = BlockedResIDs.replace(/^,|,$/g, '');
                BlockedResIDs = BlockedResIDs.replace(',', '|');
                IsBlocked = false;
                $("#ReservationIDsBlocks").val(BlockedResIDs);
              }

              if (IsBlocked) {
                $("#AllowEventMove").val(0);
              } else {
                $("#AllowEventMove").val(1);
              }

              $("#TempMBlockedDayID").val(BlockedDayIDs);

              try {
                updateFiltersInABit();
              } catch (error) {}

              return IsBlocked;
            });
            scheduler._onEventCollision = true;
          }
        }

        if (CheckALEL == 0) {
          if (!scheduler._onBeforeEventChangedAttached) {
            scheduler.attachEvent("onBeforeEventChanged", function (ev, e, is_new, original) {
              if (loginobject?.IsHousekeeper) {
                return false;
              }

              var Info = getExtraInfo(ev.room);

              if (Info[0] != "Room" && Info[0] != "VirtualRoom") {
                app.f7.toast.create({
                  text: 'Error',
                  closeButton: true,
                  closeButtonText: 'Action not allowed',
                  closeButtonColor: 'red'
                }).open();

                try {
                  updateFiltersInABit();
                } catch (error) {}

                return false;
              }

              if ($("#AllowEventMove").val() == 0) {
                return false;
              }

              var d = ev.RoomCategoryID;
              var df = original.RoomCategoryID;
              var start = ev.start_date;
              var end = ev.end_date;
              var now = new Date();

              if (end.valueOf() < now.valueOf() && Info[0] != "VirtualRoom") {
                app.f7.toast.create({
                  text: 'Error',
                  closeButton: true,
                  closeButtonText: 'Action not allowed (Past Date)',
                  closeButtonColor: 'red'
                }).open();

                try {
                  updateFiltersInABit();
                } catch (error) {}

                return false;
              }

              var tempf = ev.start_date.getMonth() + 1;
              var tempt = ev.end_date.getMonth() + 1;
              var from = ev.start_date.getDate() + "/" + tempf + "/" + ev.start_date.getFullYear() + " " + ev.start_date.getHours() + ":" + ev.start_date.getMinutes();
              var to = ev.end_date.getDate() + "/" + tempt + "/" + ev.end_date.getFullYear() + " " + ev.end_date.getHours() + ":" + ev.end_date.getMinutes();
              var FromNoTime = ev.start_date.getDate() + "/" + tempf + "/" + ev.start_date.getFullYear();
              var ToNoTime = ev.end_date.getDate() + "/" + tempt + "/" + ev.end_date.getFullYear();
              var OGFromNoTime = original.start_date.getDate() + "/" + tempf + "/" + original.start_date.getFullYear();
              var OGToNoTime = original.end_date.getDate() + "/" + tempt + "/" + original.end_date.getFullYear();
              $("#OGEventID").val(ev.id);
              $("#OGEventRoomID").val(original.room);
              $("#OGEventFrom").val(original.start_date);
              $("#OGEventTo").val(original.end_date); //do nothing if moves in same place and time

              var Otempf = original.start_date.getMonth() + 1;
              var Otempt = original.end_date.getMonth() + 1;
              var Ofrom = original.start_date.getDate() + "/" + Otempf + "/" + original.start_date.getFullYear();
              var Oto = original.end_date.getDate() + "/" + Otempt + "/" + original.end_date.getFullYear();
              var Ntempf = ev.start_date.getMonth() + 1;
              var Ntempt = ev.end_date.getMonth() + 1;
              var Nfrom = ev.start_date.getDate() + "/" + Ntempf + "/" + ev.start_date.getFullYear();
              var Nto = ev.end_date.getDate() + "/" + Ntempt + "/" + ev.end_date.getFullYear();

              if (ev.room == original.room && Ofrom == Nfrom && Oto == Nto) {
                updateFiltersInABit();
                return false;
              }

              if (ev.IsSplitted == "1" && (original.start_date.getDate() != ev.start_date.getDate() || original.end_date.getDate() != ev.end_date.getDate())) {
                app.f7.toast.create({
                  text: 'Error',
                  closeButton: true,
                  closeButtonText: "Action not allowed (Split Res.)",
                  closeButtonColor: 'red'
                }).open();
                return false;
              }

              if (ev.status == "CheckedIn" && original.start_date.getDate() != ev.start_date.getDate()) {
                app.f7.toast.create({
                  text: 'Error',
                  closeButton: true,
                  closeButtonText: "Action not allowed (Checked in)",
                  closeButtonColor: 'red'
                }).open();

                try {
                  updateFiltersInABit();
                } catch (error) {}

                return false;
              }

              if (ev.WebHotelierResID != "" && ev.WebHotelierResID != " " && ev.WebHotelierResID.indexOf("PMS") == -1 && (original.start_date.getDate() != ev.start_date.getDate() || original.end_date.getDate() != ev.end_date.getDate())) {
                app.f7.toast.create({
                  text: 'Error',
                  closeButton: true,
                  closeButtonText: "Action not allowed (Online Res.)",
                  closeButtonColor: 'red'
                }).open();

                try {
                  updateFiltersInABit();
                } catch (error) {}

                return false;
              }

              var MaybeSplit = 0;

              if (ev.IsType == "Reservation" && original.room != ev.room && ev.status == "CheckedIn") {
                MaybeSplit = 1;
              }

              if (ev.IsType == "Reservation" && original.room != ev.room && ev.status == "CheckedOut") {
                app.f7.toast.create({
                  text: 'Error',
                  closeButton: true,
                  closeButtonText: "Can't move across rooms",
                  closeButtonColor: 'red'
                }).open();

                try {
                  updateFiltersInABit();
                } catch (error) {}

                return false;
              }

              if (Info[0] == "VirtualRoom" && ev.status == "CheckedIn") {
                app.f7.toast.create({
                  text: 'Error',
                  closeButton: true,
                  closeButtonText: "Can't park checked in reservation",
                  closeButtonColor: 'red'
                }).open();

                try {
                  updateFiltersInABit();
                } catch (error) {}

                return false;
              }

              if (Info[0] == "VirtualRoom" && ev.IsSplitted == "1") {
                app.f7.toast.create({
                  text: 'Error',
                  closeButton: true,
                  closeButtonText: "Can't park splitted reservation",
                  closeButtonColor: 'red'
                }).open();

                try {
                  updateFiltersInABit();
                } catch (error) {}

                return false;
              }

              var dragmode = scheduler.getState().drag_mode;

              if (dragmode == "move") {
                var diff = (ev.start_date.getTime() - original.start_date.getTime()) / 3600000;
                var diffAbs = Math.abs(diff);
                var EventDuration = (original.end_date.getTime() - original.start_date.getTime()) / 3600000;

                if (diff > 0 && diff < EventDuration) {
                  original.end_date.setHours(original.end_date.getHours() - (EventDuration - diff));
                  var tempEvID = scheduler.addEvent({
                    start_date: original.start_date,
                    end_date: original.end_date,
                    room: original.room,
                    IsType: "MoveDupe"
                  });
                  setTimeout(function () {
                    original.end_date.setHours(original.end_date.getHours() + diff);
                  }, 50);
                } else if (diff < 0 && diffAbs < EventDuration) {
                  original.start_date.setHours(original.start_date.getHours() + (EventDuration - diffAbs));
                  var tempEvID = scheduler.addEvent({
                    start_date: original.start_date,
                    end_date: original.end_date,
                    room: original.room,
                    IsType: "MoveDupe"
                  });
                  setTimeout(function () {
                    original.start_date.setHours(original.start_date.getHours() - diff);
                  }, 50);
                } else {
                  var tempEvID = scheduler.addEvent({
                    start_date: original.start_date,
                    end_date: original.end_date,
                    room: original.room,
                    IsType: "MoveDupe"
                  });
                }
              }

              if (Info[0] == "VirtualRoom") {
                var VirtualRoomID = ev.room.replace("VirtualRoom", "");

                if (original.room.indexOf("VirtualRoom") > -1) {
                  ParkReservation(ev.ReservationID, VirtualRoomID, Info[3], from, to);
                } else {
                  ParkReservationAsk(ev.ReservationID, VirtualRoomID, Info[3], from, to, ev.ResID);
                }

                try {
                  updateFiltersInABit();
                } catch (error) {}

                return true;
              }

              var OGRoomCatID = 0;

              try {
                OGRoomCatID = original.RoomCategoryID;
              } catch (err) {}

              var ReservationIDsBlocks = $("#ReservationIDsBlocks").val();

              try {
                updateFiltersInABit();
              } catch (error) {}

              const isOriginal = !ev.id.startsWith("Split-");
              GetReservationChangeAsk(ev.ReservationID, ev.room, Info[3], OGRoomCatID, from, to, ev.status, ev.ResID, MaybeSplit, dragmode, ReservationIDsBlocks, FromNoTime, ToNoTime, OGFromNoTime, OGToNoTime, ev.SplittedResID, isOriginal, ev.splitrooms);
              $("#ReservationIDsBlocks").val('');

              try {
                updateFiltersInABit();
              } catch (error) {}

              return true; // dnd is enabled for other events
            });
            scheduler._onBeforeEventChangedAttached = true;
          }
        }

        if (!scheduler._onDblClick) {
          scheduler.attachEvent("onDblClick", function (event_id, mode, native_event_object) {
            return false;

            if (event_id != null) {
              var ev = scheduler.getEvent(event_id);
            }
          });
          scheduler._onDblClick = true;
        }

        if (!scheduler._onClick) {
          scheduler.attachEvent("onClick", async function (event_id, mode, native_event_object, event) {
            var ev = scheduler.getEvent(event_id);

            if (ev.IsType == "Reservation") {
              try {
                app.f7.preloader.show();
                localStorage.setItem("ReservationID", JSON.stringify(ev.ReservationID));
                app.f7.views.main.router.navigate('/reservation-info/', {
                  transition: 'f7-dive'
                });
                app.f7.preloader.hide();
              } catch (ex) {}

              return false;
            } else if (ev.IsType == "BlockedDay") {
              app.f7.dialog.create({
                title: 'Confirm Action',
                text: 'Are you sure you want to edit or remove this block?',
                buttons: [{
                  text: 'Edit',
                  onClick: function () {
                    // Handle edit action here
                    app.f7.preloader.show();
                    localStorage.setItem("ReservationID", JSON.stringify(ev.ReservationID));
                    app.f7.views.main.router.navigate(`/block-info/${ev.RoomBlockID}`, {
                      transition: 'f7-dive'
                    });
                  }
                }, {
                  text: 'Delete',
                  onClick: function () {
                    app.f7.dialog.confirm('Are you sure you want to delete this block?', 'Confirm Delete', function () {
                      app.f7.preloader.show();
                      app.f7.request.post(URLS.RemoveBlock, {
                        id: ev.RoomBlockID,
                        pID: loginobject.PropertyID
                      }, function (res) {
                        scheduler.deleteEvent(event_id); // or refresh events

                        app.f7.preloader.hide();
                      }, function (xhr) {
                        app.f7.preloader.hide();
                        app.f7.dialog.alert('Error removing block');
                      });
                    }, function () {// Cancel clicked
                    });
                  }
                }, {
                  text: 'Cancel',
                  onClick: function () {// Handle cancel action here
                  }
                }]
              }).open();
              return false;
            } else if (ev.IsType == "CellPrice") {} else if (ev.IsType == "ToFillRR") {
              if (loginobject?.IsHousekeeper) {
                return false;
              }

              try {
                app.f7.preloader.show();
                var ResID = ev.id.replace("ToFillRR", "");
                localStorage.setItem("ReservationID", JSON.stringify(ResID));
                app.f7.views.main.router.navigate('/reservation-info/', {
                  transition: 'f7-dive'
                });
                app.f7.preloader.hide();
              } catch (ex) {}

              return false;
            } else if (ev.IsType == "StatsWaiting" || ev.IsType == "StatsWaitingTotal" || ev.IsType == "StatsWaitingTotalBot") {
              if (loginobject?.IsHousekeeper) {
                return false;
              }

              try {
                // Not assigned
                // app.f7.preloader.show();
                var tempf = ev.start_date.getMonth() + 1;
                var FromDate = ev.start_date.getDate() + "/" + tempf + "/" + ev.start_date.getFullYear();
                var obj = {
                  RoomCategoryID: ev.RoomCategoryID,
                  DateFrom: FromDate,
                  PropertyID: loginobject.PropertyID
                };
                console.log(obj);
                localStorage.setItem("Notassigned", JSON.stringify(obj));
                app.f7.views.main.router.navigate('/main/reservations/' + "?date=" + FromDate, {
                  transition: 'f7-dive'
                }); // app.f7.preloader.hide();
              } catch (ex) {}

              return false;
            }

            return false;
          });
          scheduler._onClick = true;
        }

        var createEvent = scheduler.addEventNow;

        scheduler.addEventNow = function (e) {
          var start = arguments[0].start_date;
          var end = arguments[0].end_date;
          var now = new Date();

          if (loginobject?.IsHousekeeper) {
            return false;
          }

          if (arguments[0].room.indexOf("VirtualRoom") > -1) {
            return false;
          }

          if (end.valueOf() < now.valueOf()) {
            alert('Cant Add Res Past Date');
            return false;
          }

          var from = "#d" + start.getFullYear() + (start.getMonth() + 1) + start.getDate();
          var to = "#d" + end.getFullYear() + (end.getMonth() + 1) + end.getDate();
          var fromtime = start.getDate() + "/" + (start.getMonth() + 1) + "/" + start.getFullYear() + " ";
          var totime = end.getDate() + "/" + (end.getMonth() + 1) + "/" + end.getFullYear() + " " + end.getHours() + ":" + end.getMinutes();
          console.log(from + ',' + to + ' ,' + fromtime + ' ,' + totime + ' ,' + arguments[0].room);
          app.f7.preloader.show(); // var obj = {
          //     PropertyID: loginobject.PropertyID,
          //     UserID: loginobject.UserID,
          //     ReservationID: ev.ReservationID,
          // };
          // let response = await app.f7.request.promise.postJSON(
          //     URLS.GetReservationDetails,
          //     { obj }
          // );

          var RoomID = e.room;
          var obj = {
            PropertyID: loginobject.PropertyID,
            UserID: loginobject.UserID,
            RoomID: RoomID,
            DateFrom: fromtime,
            DateTo: totime
          };
          localStorage.setItem("newRerv", JSON.stringify(obj));
          localStorage.setItem("newRevRoomID", RoomID);
          app.f7.views.main.router.navigate('/new-reservation-home/', {
            transition: 'f7-dive'
          });
          app.f7.preloader.hide(); //GetReservation(from, to, fromtime, totime, arguments[0].room);
        };

        if (!scheduler._onBeforeEventCreated) {
          scheduler.attachEvent("onBeforeEventCreated", function (e) {
            return false;
          });
          scheduler._onBeforeEventCreated = true;
        } // disable drag and drop on RoomCategoryEvents


        if (!scheduler._onBeforeDrag) {
          scheduler.attachEvent("onBeforeDrag", function (event_id, mode, native_event_object) {
            if (loginobject?.IsHousekeeper) {
              return false;
            }

            if (event_id != null) {
              var ev = scheduler.getEvent(event_id);
              if (ev.IsType == "RoomCategory" || ev.IsType == "StatsWaiting" || ev.IsType == "StatsWaitingTotal" || ev.IsType == "StatsWaitingTotalBot" || ev.IsType == "CellPrice" || ev.IsType == "OutOfOrder" || ev.IsType == "BlockedDay" || ev.IsType == "MoveDupe") return false; // blocked drag
              //if (ev.IsSplitted == "1" && ev.SplittedToRoom != "") {
              //    return false; // blocked drag
              //}

              if (ev.IsType == "Reservation" && ev.status == "CheckedIn" && DisableMoveCheckedin == 1) {
                return false; // blocked drag
              }

              if (ev.IsType == "Reservation" && ev.status == "CheckedOut") {
                return false; // blocked drag
              } //if (ev.IsType == "Reservation" && ev.status == "CheckedOut") {
              //    return false; // blocked drag
              //}

            }

            $("#AllowEventMove").val(1);
            return true; // dnd is enabled for other events
          });
          scheduler._onBeforeDrag = true;
        }

        scheduler.init('scheduler_here', new Date(JsYear, JsMonth, JsDay), "three_month_timeline");
        scheduler.clearAll();
        let login = JSON.parse(localStorage.getItem('loginJson'));
        const propertyId = login.PropertyID;
        const userId = login.UserID;
        const UserSpecificApiKey = login?.PropertiesList?.find(property => property.PropertyName == login?.PropertyName)?.UserSpecificApiKey;
        scheduler.load(URLS.GetNewDashboardData + "?PropertyID=" + propertyId + "&UserID=" + userId + "&UserSpecificApiKey=" + UserSpecificApiKey, "json"); // CheckALEL = 1;
      };

      var LastDate = moment(Date.now()).format("DD/MM/yyyy HH:mm:ss");

      function updateFiltersInABit() {}

      function CheckToRefreshOM() {
        if (HitIt == 1) {
          CountHROM++;
          var minDate = scheduler.getState().min_date;
          var maxDate = scheduler.getState().max_date;
          var FromDate = minDate.getDate() + "/" + (minDate.getMonth() + 1) + "/" + minDate.getFullYear();
          var ToDate = maxDate.getDate() + "/" + (maxDate.getMonth() + 1) + "/" + maxDate.getFullYear(); // $("#ChkRefFromDate").val(minDateS);
          // $("#ChkRefToDate").val(maxDateS);
          // $("#ChkLastDate").val('@Model.LastDate.ToString("dd/MM/yyyy HH:mm:ss")');

          if (FromDate == null || FromDate == "" || ToDate == null || ToDate == "" || LastDate == null || LastDate == "") {
            return;
          }

          HitIt = 0;
          $.ajax({
            url: WebRootPath + '/Calendar/CheckRefreshOverviewMap?FromDate=' + FromDate + '&ToDate=' + ToDate + '&LastDate=' + LastDate + '&PropertyID=' + loginobject.PropertyID,
            type: "POST",
            async: true,
            success: function (data) {
              var dataparts = data.split("|");
              var result = dataparts[0];

              if (result == 1 && CountHROM > 0) {
                if ($("#hStopAutoRefresh").val() == 1) {
                  var UpSkip = $("#UpdatesSkipped").html();
                  UpSkip = +UpSkip + 1;
                  $("#UpdatesSkipped").html(UpSkip);

                  try {
                    $(".schType_MoveDupe").each(function () {
                      PlanDeleteEvent($(this).attr('event_id'));
                    });
                  } catch (err) {}

                  try {
                    updateFiltersInABit();
                  } catch (error) {}
                } else {
                  $("#HScrollSched_top").val($(".dhx_timeline_scrollable_data").scrollTop());
                  $("#HScrollSched_left").val($(".dhx_timeline_scrollable_data").scrollLeft());

                  try {
                    ClearAllAndReloadScheduler();
                  } catch (err) {}
                }
              }

              LastDate = dataparts[1];
              HitIt = 1;
            }
          });
        }
      }

      function ClearAllAndReloadScheduler() {
        $(".dhx_timeline_scrollable_data").on('scroll', function () {
          $("#HScrollSched_top").val($(".dhx_timeline_scrollable_data").scrollTop());
          $("#HScrollSched_left").val($(".dhx_timeline_scrollable_data").scrollLeft());
        });
        scheduler.clearAll();
        let login = JSON.parse(localStorage.getItem('loginJson'));
        const propertyId = login.PropertyID;
        const userId = login.UserID;
        const UserSpecificApiKey = login?.PropertiesList?.find(property => property.PropertyName == login?.PropertyName)?.UserSpecificApiKey;
        scheduler.load(URLS.GetNewDashboardData + "?PropertyID=" + propertyId + "&UserID=" + userId + "&UserSpecificApiKey=" + UserSpecificApiKey, "json");
      }

      async function GetPlanData() {
        app.f7.preloader.show();
        var info = actions.GetDashboardinfo();
        await actions.GetReservationsForPlan(" ", " ").then(value => {
          $$("#RoomID").show();
          this.$setState({
            PlanData: value,
            Info: info
          });
          app.f7.preloader.hide();
          $(window).on("resize", resize);
          resize();
          $(".calendarpage").on("scroll", function () {
            var scrollTop = $(".calendarpage").scrollTop();
            $(".timeline-item-content").scrollTop(scrollTop);
          });
        });
      } //GetPlanData();


      this.InitCalendar();

      function GetBlockedDay(BlockedDayID) {}

      function OpenNewGroupReservation(GroupID, A, B) {}

      function updateRoomsShowByCategory(RoomCategoryID) {}

      function updateRoomsShowByProperty(PropertyID) {}

      function updateRoomsShowByApiKey(ApiKeyID) {} // With custom date format


      calendarRangeFrom2 = app.f7.calendar.create({
        inputEl: '#plan-calendar-From',
        dateFormat: 'dd/mm/yyyy',
        date: today,
        value: [new Date()],
        closeOnSelect: true,
        on: {
          close: function (c) {
            var CalendarDate = calendarRangeFrom2.getValue();
            var CheckiInDate = new Date(CalendarDate[0]);
            scheduler.setCurrentView(CheckiInDate);
          }
        }
      });
    },
    pageReinit: function (e, page) {
      var self = this;
      self.InitCalendar();
    }
  },
  id: '8f9bbbaf77',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page style="background-color: #f7f7f7;" data-name=reservationscalendar><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link icon-only panel-open" data-panel=left><i class="icon f7-icons if-not-md">menu</i> <i class="icon material-icons if-md">menu</i></a></div><div class="title sliding">';
      r += Template7Helpers.t.call(ctx_1, 'reservationsCalendar', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div></div><input hidden id=OGEventID value=""> <input hidden id=OGEventRoomID value=""> <input hidden id=OGEventFrom value=""> <input hidden id=OGEventTo value=""> <input hidden id=AllowEventMove value=1> <input hidden id=ReservationIDsBlocks value=""><div class=page-content style=padding-bottom:0px><input hidden id=HScrollSched_top> <input hidden id=HScrollSched_left><div id=scheduler_here class="dhx_cal_container dhx_scheduler_month_timeline CustEventShape_1" role=application><div style=position:relative><div class=row><span class=col-100><div class=item-inner style="margin-left: 5px;"><div style="display: flex;justify-content: space-between;align-items: center;"><div class="item-input-wrap plan-header-wrapper"><!-- <div class="dhx_cal_prev_button"\r\n                                            style="z-index: 99; left:0;border: 1px solid black;padding-right: 10px;top: 4px;"\r\n                                            role="button" aria-label="Previous">&nbsp;\r\n                                        </div> --><div style="font-size: 15px;">Start from:</div><div class=cal-start-input-wrap><div class=PmsIconCalendar></div><input name=checkindate class=dhx_cal_date type=text readonly=readonly id=plan-calendar-From></div><div style="margin-left: 3px;font-size: 15px;letter-spacing: -2px;font-weight: 600;">+ 3 M</div><!-- <div style="z-index: 99;border: 1px solid black;padding-left: 10px;left: 170px;top: 4px;"\r\n                                            class="dhx_cal_next_button" role="button" aria-label="Next">&nbsp;</div> --></div><!-- <div style="display: flex;">\r\n                                        <div class="plan-size-btn minus-btn" @click=changePlanSize(-1)><i\r\n                                                class="material-icons">\r\n                                                remove </i></div>\r\n                                        <div class="plan-size-btn plus-btn" @click=changePlanSize(1)><i\r\n                                                class="material-icons">\r\n                                                add </i></div>\r\n                                    </div> --></div></div></span><!-- <span class="col-50" style="padding-right: 15px;">\r\n\r\n                            <div class="OMViewOptions" style="text-align: right;">\r\n\r\n                                <span @click="OMChangeViewFilter(2)" id="OMViewOption2" class="btnHoverClickOp ">14 Day\r\n                                    View</span>\r\n                                <span @click="OMChangeViewFilter(3)" id="OMViewOption3"\r\n                                    class="btnHoverClickOp OMVOAct">31\r\n                                    Day View</span>\r\n                            </div>\r\n                        </span> --></div><div id=TLDDropRoomCont style="display: block;"><span @click=ToggleViewByRoomsType() id=TLDropRooms data-viewtype=0>By Type</span> <i class="fa fa-angle-down"></i></div></div><div class=dhx_cal_navline style="width: 100%; height: 45px; left: 0px; top: 0px;display: none;"><div class=dhx_nav_container><div class=dhx_cal_prev_button style="z-index: 99;" role=button aria-label=Previous>&nbsp;</div><div class="CalDateCont btnHoverClickOp"><div class=PmsIconCalendar></div><div id=dhx_cal_date class=dhx_cal_date>31-01-2022 – 02-03-2022</div></div><div style="z-index: 99;margin-left:17px" class=dhx_cal_next_button role=button aria-label=Next>&nbsp;</div><div id=dhx_cal_date class=dhx_cal_date></div><div onclick=CalClickTodayFIC(); class="CustTodayButton btnHoverClickOp">Today</div><div class=OMViewOptions><span style=display:none; @click=OMChangeViewFilter(1) id=OMViewOption1 class=btnHoverClickOp>7 Day View</span> <span @click=OMChangeViewFilter(2) id=OMViewOption2 class=btnHoverClickOp>14 Day View</span> <span @click=OMChangeViewFilter(3) id=OMViewOption3 class="btnHoverClickOp OMVOAct">31 Day View</span></div></div><div style="z-index: 99;display:none;" class=dhx_cal_today_button aria-label=Today role=button>Today</div><div style="z-index: 99;display:none;" id=week_timeline_tab class="dhx_cal_tab dhx_cal_tab_first" name=week_timeline_tab aria-label=WEEK role=button aria-pressed=false>WEEK</div><div style="z-index: 99; display: none;" id=two_week_timeline_tab class=dhx_cal_tab name=two_week_timeline_tab aria-label="2 WEEKS" role=button aria-pressed=false>2 WEEKS</div><div style="z-index: 99;display: none;" id=month_timeline_tab class="dhx_cal_tab dhx_cal_tab_last active" name=month_timeline_tab aria-label=MONTH role=button aria-pressed=true>MONTH</div></div><div class=dhx_cal_header id=dhx_cal_header style="border-top: 1px solid lightgray; top: 46px; width: 2350px; height: 55px; left: -1px;"></div><div class=dhx_cal_data id=dhx_cal_data style="width: 100%; height: 689px; left: 0px; top: 97px;"></div><div class=dhx_timeline_scale_header style="width: 179px; height: 50px; line-height: 50px; top: 47px; left: 0px;"></div></div></div><div id=contextMenu class="contextMenu dropdown clearfix" style="display: none; left: 142px; top: 70px;"><div id=contextMenuHeader><div style=width:285px;float:left><div class="row clearfix"><div class=col-md-7 style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;"><span style="display: inherit !important; width: unset !important" id=contextMenuHeaderCust title="Sarris Vassilis">Sarris Vassilis</span></div><div class=col-md-5 style="padding-left: 0;"><span style="background-color: #fff; color: #676767; border-radius: 4px; padding: 1px 5px 1px 5px;" id=contextMenuHeaderStat>Confirmed</span></div></div><span id=contextMenuHeaderMob style="display:inline-block;width:61%;padding-bottom:5px;float:left;text-overflow: ellipsis; white-space: nowrap; overflow: hidden;" title=4321>4321</span> <span id=contextMenuHeaderRoom style=display:inline-block;width:39%;padding-bottom:5px;float:left;>Room: 207</span></div><div style=float:right id=contextMenuHeaderActions><div style="padding-right: 10px;font-size: 14px;cursor: pointer;width: auto;" title="Reservation Color" id=colorPickResCol class="colorPickSelector fa fa-paint-brush"></div><i title="Cancel Reservation" onclick="CalCancelReservationAsk(126670,\'PMS000126670\',0)" class="fa fa-trash contextMenuHeaderActionThrash contextCl"></i> <i title=Close class="fa fa-times contextMenuHeaderActionClose contextCl"></i></div></div></div><div id=contextMenuSimple class="contextMenu dropdown clearfix" style="display: none;"><div id=contextMenuSimpleHeader><span id=contextMenuSimpleHeaderCust></span></div><ul id=contextMenuSimpleUl class=contextRightDrop role=menu aria-labelledby=dropdownMenu style="display: block;position: static;padding: 5px 0;"></ul></div><div id=RtooltipMenu class="RtooltipMenu dropdown clearfix" style="display: none;"></div></div>';
      return r;
    }(this);
  },

  style: `
    .dhxCustTodayHeader {
        background-color: #dcd2f5;
        box-shadow: 0px 0px 7px 0px grey;
    }

    .disabled-btn {
        opacity: 0.5;
        pointer-events: none;
    }

    .plan-size-btn {
        padding: 3px 5px;
        border: 1px solid black;
        border-radius: 8px;
        font-size: 13px;
        margin: 3px;
    }

    /* mini plan */
    .schdResBasicsSimpleMini {
        line-height: 8px;
        height: 18px;
        margin-top: 1px;
        overflow: hidden;
    }

    .EC_Deposit .schdResBasicsSimpleMini:after {
        background: repeating-linear-gradient(135deg, rgba(0, 0, 0, .4), transparent 3px, transparent 9px, transparent 9px);
        position: absolute;
        left: 0;
        height: 100%;
        width: 50%;
        top: 0;
        content: "";
    }

    .EC_Paid .schdResBasicsSimpleMini:after {
        background: repeating-linear-gradient(135deg, rgba(0, 0, 0, .4), transparent 3px, transparent 9px, transparent 9px);
        position: absolute;
        left: 0;
        height: 100%;
        width: 100%;
        top: 0;
        content: "";
    }

    .ToolClickSimpleMini {
        border: solid 1px white;
        border-radius: 15px;
        width: 15px;
        height: 15px;
        background: #fff;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        cursor: pointer;
        float: left;
        margin-top: 1px;
        margin-right: 4px;
    }

    .ToolClickSimpleMini .CalIconSource {
        display: inline-block;
        width: 9px;
        height: 9px;
        margin-right: 1px;
        background-size: cover;
        margin-top: 2px;
    }

    .custdivsimpleMini {
        height: 11px;
        width: 100%;
        font-size: 10px;
        line-height: 10px;
        overflow: hidden;
        font-weight: 700;
        height: 17px;
        font-size: 15px;
        line-height: 16px;
    }

    .residdivsimpleMini,
    .residdivDefMini {
        display: none;
        height: 6px;
        font-size: 8px;
        line-height: 6px;
        font-weight: 700;
    }

    .SchdMiniCalendar {}

    .SchdMiniCalendar .SchdBlockedDay {
        font-size: 14px !important;
        font-weight: 700;
        padding-top: 0px !important;
        display: flex;
        align-items: center;
    }

    .SchdMiniCalendar .schdResBasics {
        height: 17px;
        overflow: hidden;
    }

    .SchdMiniCalendar .custdivDefMini {
        height: 17px;
        width: 100%;
        font-size: 14px;
        overflow: hidden;
        font-weight: 700;
        line-height: 16px;
    }

    .SchdMiniCalendar .schdResIcons,
    .SchdMiniCalendar .sbyextrainfo {
        display: none;
    }

    /* mini plan end */

    /* small plan */
    .schdResBasicsSimpleSmall {
        line-height: 13px;
        height: 23px;
        margin-top: 1px;
        overflow: hidden;
    }

    .EC_Deposit .schdResBasicsSimpleSmall:after {
        background: repeating-linear-gradient(135deg, rgba(0, 0, 0, .4), transparent 3px, transparent 9px, transparent 9px);
        position: absolute;
        left: 0;
        height: 100%;
        width: 50%;
        top: 0;
        content: "";
    }

    .EC_Paid .schdResBasicsSimpleSmall:after {
        background: repeating-linear-gradient(135deg, rgba(0, 0, 0, .4), transparent 3px, transparent 9px, transparent 9px);
        position: absolute;
        left: 0;
        height: 100%;
        width: 100%;
        top: 0;
        content: "";
    }

    .ToolClickSimpleSmall {
        border: solid 1px white;
        border-radius: 15px;
        width: 19px;
        height: 19px;
        background: #fff;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        cursor: pointer;
        float: left;
        margin-top: 1px;
        margin-right: 4px;
    }

    .ToolClickSimpleSmall .CalIconSource {
        display: inline-block;
        width: 12px;
        height: 12px;
        margin-right: 2px;
        background-size: cover;
        margin-top: 1px;
    }

    .custdivsimpleSmall {
        height: 15px;
        width: 100%;
        font-size: 12px;
        overflow: hidden;
        font-weight: 700;
        position: relative;
        top: -1px;
    }

    .residdivsimpleSmall,
    .residdivDefSmall {
        height: 15px;
        font-size: 8px;
        line-height: 4px;
        font-weight: 700;
    }

    .SchdSmallCalendar {}

    .SchdSmallCalendar .SchdBlockedDay {
        font-size: 12px !important;
        font-weight: 700;
        padding-top: 0px !important;
        display: flex;
        align-items: center;
    }

    /* small plan end */

    /* normal plan */
    .schdResBasicsSimpleNormal {
        line-height: 18px;
        height: 28px;
        margin-top: 1px;
        overflow: hidden;
    }

    .EC_Deposit .schdResBasicsSimpleNormal:after {
        background: repeating-linear-gradient(135deg, rgba(0, 0, 0, .4), transparent 3px, transparent 9px, transparent 9px);
        position: absolute;
        left: 0;
        height: 100%;
        width: 50%;
        top: 0;
        content: "";
    }

    .EC_Paid .schdResBasicsSimpleNormal:after {
        background: repeating-linear-gradient(135deg, rgba(0, 0, 0, .4), transparent 3px, transparent 9px, transparent 9px);
        position: absolute;
        left: 0;
        height: 100%;
        width: 100%;
        top: 0;
        content: "";
    }

    .ToolClickSimpleNormal {
        border: solid 1px white;
        border-radius: 15px;
        width: 25px;
        height: 25px;
        background: #fff;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        cursor: pointer;
        float: left;
        margin-right: 4px;
        margin-top: 1px;
    }

    .ToolClickSimpleNormal .CalIconSource {
        display: inline-block;
        width: 15px;
        height: 15px;
        margin-right: 4px;
        background-size: cover;
        margin-top: 2px;
    }

    .custdivsimpleNormal {
        height: 14px;
        width: 100%;
        font-size: 12px;
        overflow: hidden;
        line-height: 14px;
        font-weight: 700;
    }

    .residdivsimpleNormal,
    .residdivDefNormal {
        height: 13px;
        font-size: 11px;
        line-height: 13px;
        font-weight: 700;
    }

    .SchdNormalCalendar {}

    .SchdNormalCalendar .SchdBlockedDay {
        font-size: 12px !important;
        font-weight: 700;
        padding-top: 0px !important;
        display: flex;
        align-items: center;
    }

    /* normal plan end */

    /* big plan */
    .schdResBasicsSimpleBig {
        line-height: 19px;
        height: 35px;
        overflow: hidden;
    }


    .EC_Deposit .schdResBasicsSimpleBig:after {
        background: repeating-linear-gradient(135deg, rgba(0, 0, 0, .4), transparent 3px, transparent 9px, transparent 9px);
        position: absolute;
        left: 0;
        height: 100%;
        width: 50%;
        top: 0;
        content: "";
    }

    .EC_Paid .schdResBasicsSimpleBig:after {
        background: repeating-linear-gradient(135deg, rgba(0, 0, 0, .4), transparent 3px, transparent 9px, transparent 9px);
        position: absolute;
        left: 0;
        height: 100%;
        width: 100%;
        top: 0;
        content: "";
    }

    .ToolClickSimpleBig {
        border: solid 1px white;
        border-radius: 15px;
        width: 27px;
        height: 27px;
        background: #fff;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        cursor: pointer;
        float: left;
        margin-top: 1px;
        margin-right: 4px;
    }

    .ToolClickSimpleBig .CalIconSource {
        display: inline-block;
        width: 16px;
        height: 16px;
        margin-right: 4px;
        background-size: cover;
        margin-top: 1px;
    }

    .custdivsimpleBig {
        height: 17px;
        width: 100%;
        font-size: 14px;
        overflow: hidden;
        font-weight: 700;
    }

    .residdivsimpleBig,
    .residdivDefBig {
        height: 12px;
        font-size: 11px;
        line-height: 12px;
        font-weight: 700;
    }

    .SchdBigCalendar {}

    .SchdBigCalendar .SchdBlockedDay {
        font-size: 14px !important;
        font-weight: 700;
        padding-top: 0px !important;
        display: flex;
        align-items: center;
    }

    /* big plan end */

    /* XL plan */
    .schdResBasicsSimpleXL {
        line-height: 27px;
        height: 43px;
        margin-top: 1px;
        overflow: hidden;
    }

    .EC_Deposit .schdResBasicsSimpleXL:after {
        background: repeating-linear-gradient(135deg, rgba(0, 0, 0, .4), transparent 3px, transparent 9px, transparent 9px);
        position: absolute;
        left: 0;
        height: 100%;
        width: 50%;
        top: 0;
        content: "";
    }

    .EC_Paid .schdResBasicsSimpleXL:after {
        background: repeating-linear-gradient(135deg, rgba(0, 0, 0, .4), transparent 3px, transparent 9px, transparent 9px);
        position: absolute;
        left: 0;
        height: 100%;
        width: 100%;
        top: 0;
        content: "";
    }

    .ToolClickSimpleXL {
        border: solid 1px white;
        border-radius: 15px;
        width: 27px;
        height: 27px;
        background: #fff;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        cursor: pointer;
        float: left;
        margin-top: 0px;
        margin-right: 4px;
    }

    .ToolClickSimpleXL .CalIconSource {
        display: inline-block;
        width: 16px;
        height: 16px;
        margin-right: 4px;
        background-size: cover;
        margin-top: 1px;
    }

    .custdivsimpleXL {
        height: 12px;
        width: 100%;
        line-height: 12px;
        font-size: 16px;
        overflow: hidden;
        font-weight: 700;
    }

    .residdivsimpleXL,
    .residdivDefXL {
        height: 24px;
        font-size: 12px;
        line-height: 22px;
        font-weight: 700;
    }

    .SchdXLCalendar {}

    .SchdXLCalendar .SchdBlockedDay {
        font-size: 16px !important;
        font-weight: 700;
        padding-top: 0px !important;
        display: flex;
        align-items: center;
    }

    /* XL plan end */
    .cal-start-input-wrap:has(.input-focused) {
        border-color: black;
    }

    .plan-header-wrapper {
        padding-top: 5px;
        display: flex;
        align-items: center;
    }

    .cal-start-input-wrap {
        border-radius: 5px;
        margin-left: 5px;
        border: 1px solid #9a9a9a;
        padding-left: 5px;
        width: 115px;
    }

    .dhx_cal_container {
        font-family: 'Open Sans';
    }

    #plan-calendar-From {
        /* height: 40px; */
        border: none;
        /* text-align: center; */
        font-size: 16px;
        padding-left: 10px;
        padding: 0 0 0 10px;
    }

    .dhx_cal_event_line.event_Cancelled.schType_Reservation:after,
    .dhx_cal_event_line.event_NoShow.schType_Reservation:after,
    .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
    .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
    .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
    .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
    .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
    .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
    .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
    .dhx_cal_event_line.schType_undefined:after {
        border-width: 30px 18px 0 0;
    }

    .dhx_cal_event_line.event_Cancelled.schType_Reservation:before,
    .dhx_cal_event_line.event_NoShow.schType_Reservation:before,
    .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
    .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
    .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
    .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
    .dhx_cal_event_line.event_CheckOutToday.schType_Reservation:before,
    .dhx_cal_event_line.event_Paid.schType_Reservation:before,
    .dhx_cal_event_line.schType_undefined:before {
        border-width: 0px 0px 30px 18px;
    }



    .dhx_cal_event_line.event_Cancelled.schType_Reservation:after,
    .dhx_cal_event_line.event_NoShow.schType_Reservation:after,
    .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
    .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
    .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
    .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
    .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
    .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
    .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
    .dhx_cal_event_line.schType_undefined:after {
        border-width: 30px 18px 0 0;
    }

    .dhx_cal_event_line.event_Cancelled.schType_Reservation:before,
    .dhx_cal_event_line.event_NoShow.schType_Reservation:before,
    .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
    .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
    .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
    .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
    .dhx_cal_event_line.event_CheckOutToday.schType_Reservation:before,
    .dhx_cal_event_line.event_Paid.schType_Reservation:before,
    .dhx_cal_event_line.schType_undefined:before {
        border-width: 0px 0px 30px 18px;
    }

    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Cancelled.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_NoShow.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:after {
        border-width: 30px 7px 0 0;
    }

    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Cancelled.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_NoShow.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:before {
        border-width: 0px 0px 30px 7px;
    }

    @media(max-width:1440px) {

        .dhx_cal_event_line.event_Cancelled.schType_Reservation:after,
        .dhx_cal_event_line.event_NoShow.schType_Reservation:after,
        .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
        .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
        .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
        .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
        .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
        .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
        .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
        .dhx_cal_event_line.schType_undefined:after {
            border-width: 30px 9px 0 0;
        }

        .dhx_cal_event_line.event_Cancelled.schType_Reservation:before,
        .dhx_cal_event_line.event_NoShow.schType_Reservation:before,
        .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
        .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
        .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
        .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
        .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
        .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
        .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
        .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
        .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
        .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
        .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
        .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
        .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
        .dhx_cal_event_line.schType_undefined:before {
            border-width: 0px 0px 30px 9px;
        }

        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Cancelled.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_NoShow.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:after {
            border-width: 30px 5px 0 0;
        }

        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Cancelled.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_NoShow.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:before {
            border-width: 0px 0px 30px 5px;
        }

        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Cancelled.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_NoShow.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:after {
            border-width: 30px 7px 0 0;
        }

        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Cancelled.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_NoShow.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:before {
            border-width: 0px 0px 30px 7px;
        }
    }

    .CustEventShape_1 .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
    .CustEventShape_1 .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
    .CustEventShape_1 .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
    .CustEventShape_1 .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
    .CustEventShape_1 .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
    .CustEventShape_1 .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
    .CustEventShape_1 .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
    .CustEventShape_1 .dhx_cal_event_line.schType_undefined:after {
        border-width: 30px 18px 0 0;
        border-bottom-color: transparent !important;
        border-right-color: transparent !important;
        border-left-color: transparent !important;
    }

    .CustEventShape_1 .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
    .CustEventShape_1 .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
    .CustEventShape_1 .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
    .CustEventShape_1 .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
    .CustEventShape_1 .dhx_cal_event_line.event_CheckOutToday.schType_Reservation:before,
    .CustEventShape_1 .dhx_cal_event_line.event_Paid.schType_Reservation:before,
    .CustEventShape_1 .dhx_cal_event_line.schType_undefined:before {
        border-width: 0px 0px 30px 18px;
        border-right-color: transparent !important;
        border-top-color: transparent !important;
        border-left-color: transparent !important;
    }

    .CustEventShape_2 .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
    .CustEventShape_2 .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
    .CustEventShape_2 .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
    .CustEventShape_2 .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
    .CustEventShape_2 .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
    .CustEventShape_2 .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
    .CustEventShape_2 .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
    .CustEventShape_2 .dhx_cal_event_line.schType_undefined:after {
        border-width: 30px 0 30px 18px;
        border-top-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
    }

    .CustEventShape_2 .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
    .CustEventShape_2 .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
    .CustEventShape_2 .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
    .CustEventShape_2 .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
    .CustEventShape_2 .dhx_cal_event_line.event_CheckOutToday.schType_Reservation:before,
    .CustEventShape_2 .dhx_cal_event_line.event_Paid.schType_Reservation:before,
    .CustEventShape_2 .dhx_cal_event_line.schType_undefined:before {
        border-width: 30px 18px 30px 0;
        border-top-color: transparent !important;
        border-bottom-color: transparent !important;
        border-left-color: transparent !important;
    }

    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.schType_undefined:after,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_Cancelled.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_NoShow.schType_Reservation:after {
        border-width: 30px 0 30px 34px;
        right: -35px;
    }

    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.schType_undefined:before {
        border-width: 30px 34px 30px 0;
        left: -35px;
    }

    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:after,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Cancelled.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_NoShow.schType_Reservation:after {
        border-width: 30px 0 30px 13px;
        right: -14px;
    }

    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:before {
        border-width: 30px 13px 30px 0;
        left: -14px;
    }

    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:after {
        border-width: 30px 7px 0 0;
    }

    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:before {
        border-width: 0px 0px 30px 7px;
    }

    @media(max-width:1440px) {

        .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
        .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
        .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
        .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
        .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
        .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
        .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
        .dhx_cal_event_line.schType_undefined:after {
            border-width: 30px 9px 0 0;
        }

        .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
        .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
        .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
        .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
        .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
        .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
        .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
        .dhx_cal_event_line.schType_undefined:before {
            border-width: 0px 0px 30px 9px;
        }

        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:after {
            border-width: 30px 5px 0 0;
        }

        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:before {
            border-width: 0px 0px 30px 5px;
        }

        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:after {
            border-width: 30px 7px 0 0;
        }

        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:before {
            border-width: 0px 0px 30px 7px;
        }

        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.schType_undefined:after,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_Cancelled.schType_Reservation:after,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_NoShow.schType_Reservation:after {
            border-width: 30px 0 30px 15px;
            right: -16px;
        }

        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.schType_undefined:before {
            border-width: 30px 15px 30px 0;
            left: -16px;
        }
    }

    .EC_Deposit .schdResIcons:after {
        background: repeating-linear-gradient(135deg, rgba(0, 0, 0, 0.4), transparent 3px, transparent 9px, transparent 9px);
        position: absolute;
        left: 0;
        height: 100%;
        width: 50%;
        top: 0;
        content: "";
    }

    .EC_Paid .schdResIcons:after {
        background: repeating-linear-gradient(135deg, rgba(0, 0, 0, 0.4), transparent 3px, transparent 9px, transparent 9px);
        position: absolute;
        left: 0;
        height: 100%;
        width: 100%;
        top: 0;
        content: "";
    }

    .schdResBasicsSimpleNormal {
        line-height: 18px;
        height: 28px;
        margin-top: 1px;
        overflow: hidden;
    }

    .ToolClickSimpleNormal {
        border: solid 1px white;
        border-radius: 15px;
        width: 25px;
        height: 25px;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        float: left;
        margin: 0;
        position: absolute;
    }

    .custdivsimpleNormal {
        height: 14px;
        width: 100%;
        font-size: 0.7rem;
        overflow: hidden;
        line-height: 14px;
        font-weight: 700;
    }

    .residdivsimpleNormal,
    .residdivDefNormal {
        height: 13px;
        font-size: 11px;
        line-height: 13px;
        font-weight: 700;
    }

    .ToolClickSimpleNormal .CalIconSource {
        display: inline-block;
        width: 15px;
        height: 15px;
        margin: 0;
        background-size: cover;
    }

    .schdResBasicsSimpleNormal.schdRBFJS {
        color: #000;
    }

    .schdResBasicsSimpleNormal>div:nth-of-type(2) {
        padding-left: 28px;
        width: unset !important;
    }

    .ToFillE {
        text-align: left;
        width: 100%;
        border: none;
        border-left: solid 5px #A6A6A6;
        font-size: 12px !important;
        color: #000;
        padding: 0;
        display: flex;
        align-items: center;
        overflow: hidden;
        white-space: pre;
        padding-left: 3px;
    }

    .schType_RoomCategory .dhx_event_resize {
        display: none !important;
    }

    /* custom plan reservation colors */
    .dhx_cal_event_line.schType_Reservation.EvCo_1abc9c {
        background: #1abc9c !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_16a085 {
        background: #16a085 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_85bb65 {
        background: #85bb65 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_2ecc71 {
        background: #2ecc71 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_27ae60 {
        background: #27ae60 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_3498db {
        background: #3498db !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_1796B0 {
        background: #1796B0 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_2980b9 {
        background: #2980b9 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_4a4ab1 {
        background: #4a4ab1 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_9b59b6 {
        background: #9b59b6 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_8e44ad {
        background: #8e44ad !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_34495e {
        background: #34495e !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_2c3e50 {
        background: #2c3e50 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_f1c40f {
        background: #f1c40f !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_f39c12 {
        background: #f39c12 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_e67e22 {
        background: #e67e22 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_d35400 {
        background: #d35400 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_e74c3c {
        background: #e74c3c !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_c0392b {
        background: #c0392b !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_ab0253 {
        background: #ab0253 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_ffffff {
        background: #ffffff !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_bdc3c7 {
        background: #bdc3c7 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_95a5a6 {
        background: #95a5a6 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_7f8c8d {
        background: #7f8c8d !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_1abc9c:after,
    .dhx_cal_event_line.schType_Reservation.EvCo_1abc9c:before {
        border-color: #1abc9c !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_16a085:after,
    .dhx_cal_event_line.schType_Reservation.EvCo_16a085:before {
        border-color: #16a085 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_85bb65:after,
    .dhx_cal_event_line.schType_Reservation.EvCo_85bb65:before {
        border-color: #85bb65 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_2ecc71:after,
    .dhx_cal_event_line.schType_Reservation.EvCo_2ecc71:before {
        border-color: #2ecc71 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_27ae60:after,
    .dhx_cal_event_line.schType_Reservation.EvCo_27ae60:before {
        border-color: #27ae60 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_3498db:after,
    .dhx_cal_event_line.schType_Reservation.EvCo_3498db:before {
        border-color: #3498db !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_1796B0:after,
    .dhx_cal_event_line.schType_Reservation.EvCo_1796B0:before {
        border-color: #1796B0 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_2980b9:after,
    .dhx_cal_event_line.schType_Reservation.EvCo_2980b9:before {
        border-color: #2980b9 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_4a4ab1:after,
    .dhx_cal_event_line.schType_Reservation.EvCo_4a4ab1:before {
        border-color: #4a4ab1 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_9b59b6:after,
    .dhx_cal_event_line.schType_Reservation.EvCo_9b59b6:before {
        border-color: #9b59b6 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_8e44ad:after,
    .dhx_cal_event_line.schType_Reservation.EvCo_8e44ad:before {
        border-color: #8e44ad !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_34495e:after,
    .dhx_cal_event_line.schType_Reservation.EvCo_34495e:before {
        border-color: #34495e !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_2c3e50:after,
    .dhx_cal_event_line.schType_Reservation.EvCo_2c3e50:before {
        border-color: #2c3e50 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_f1c40f:after,
    .dhx_cal_event_line.schType_Reservation.EvCo_f1c40f:before {
        border-color: #f1c40f !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_f39c12:after,
    .dhx_cal_event_line.schType_Reservation.EvCo_f39c12:before {
        border-color: #f39c12 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_e67e22:after,
    .dhx_cal_event_line.schType_Reservation.EvCo_e67e22:before {
        border-color: #e67e22 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_d35400:after,
    .dhx_cal_event_line.schType_Reservation.EvCo_d35400:before {
        border-color: #d35400 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_e74c3c:after,
    .dhx_cal_event_line.schType_Reservation.EvCo_e74c3c:before {
        border-color: #e74c3c !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_c0392b:after,
    .dhx_cal_event_line.schType_Reservation.EvCo_c0392b:before {
        border-color: #c0392b !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_ab0253:after,
    .dhx_cal_event_line.schType_Reservation.EvCo_ab0253:before {
        border-color: #ab0253 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_ffffff:after,
    .dhx_cal_event_line.schType_Reservation.EvCo_ffffff:before {
        border-color: #ffffff !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_bdc3c7:after,
    .dhx_cal_event_line.schType_Reservation.EvCo_bdc3c7:before {
        border-color: #bdc3c7 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_95a5a6:after,
    .dhx_cal_event_line.schType_Reservation.EvCo_95a5a6:before {
        border-color: #95a5a6 !important;
    }

    .dhx_cal_event_line.schType_Reservation.EvCo_7f8c8d:after,
    .dhx_cal_event_line.schType_Reservation.EvCo_7f8c8d:before {
        border-color: #7f8c8d !important;
    }
`,
  styleScoped: false
};

function findInArrayN(array, key) {
  for (var i = 0; i < array.length; i++) {
    if (key == array[i].key) return array[i];
  }

  return null;
}

function getExtraInfo(key) {
  var Room = findInArrayN(scheduler.serverList("rooms"), key);
  var Info = [Room.type, Room.IsBookable, Room.AllowsChildren, Room.RoomCategoryID];
  return Info;
}

function PlanDeleteEvent(ID) {
  try {
    scheduler.deleteEvent(ID);
  } catch (err) {}
}

function GetReservationChangeAsk(ResID, NewRoomID, NewRoomCatID, OGRoomCatID, From, To, Status, ResIDCode, Split, dragmode, ReservationIDsBlocks, FromNoTime, ToNoTime, OGFromNoTime, OGToNoTime, SplitID, isOriginal, splitrooms) {
  app.f7.dialog.confirm("Edit Reservation?", "", function () {
    GetReservationChange(ResID, NewRoomID, NewRoomCatID, From, To, OGRoomCatID, Status, dragmode, SplitID, isOriginal, splitrooms);
  }, function () {
    try {
      CustomClearAllAndReloadScheduler();
    } catch (err) {}
  });
}

function CustomClearAllAndReloadScheduler() {
  $(".dhx_timeline_scrollable_data").on('scroll', function () {
    $("#HScrollSched_top").val($(".dhx_timeline_scrollable_data").scrollTop());
    $("#HScrollSched_left").val($(".dhx_timeline_scrollable_data").scrollLeft());
  });
  scheduler.clearAll();
  let login = JSON.parse(localStorage.getItem('loginJson'));
  const propertyId = login.PropertyID;
  const userId = login.UserID;
  const UserSpecificApiKey = login?.PropertiesList?.find(property => property.PropertyName == login?.PropertyName)?.UserSpecificApiKey;
  scheduler.load(URLS.GetNewDashboardData + "?PropertyID=" + propertyId + "&UserID=" + userId + "&UserSpecificApiKey=" + UserSpecificApiKey, "json");
}

function GetReservationChange(ResID, NewRoomID, NewRoomCatID, From, To, OGRoomCatID, Status, dragmode, SplitID, isOriginal, splitrooms) {
  const noChangeDates = (isOriginal && splitrooms && splitrooms != "") == true;
  var obj = {
    PropertyID: loginobject.PropertyID,
    UserID: loginobject.UserID,
    RoomCategoryID: NewRoomCatID,
    DateFrom: From,
    DateTo: To,
    ReservationID: ResID,
    RoomID: NewRoomID,
    SplitID,
    FromPlan: "calendar-move",
    noChangeDates
  };
  const UserName = `${loginobject.FirstName} ${loginobject.LastName}`;

  try {
    app.f7.preloader.show();
    let response;

    if (!isOriginal && SplitID) {
      response = app.f7.request.promise.postJSON(`${URLS.SubmitSplitReservation}?QSReservationID=${ResID}&QSFrom=${From}&QSTo=${To}&QSRoomID=${NewRoomID}&QSRoomCatID=${NewRoomCatID}&QuickSplit=${1}&SplittedID=${SplitID}&aPropertyID=${obj.PropertyID}&aUserName=${obj.UserID}&aUserName=${UserName}`);
    } else {
      response = app.f7.request.promise.postJSON(URLS.EditReservationDetails, {
        obj
      });
    }

    app.f7.preloader.hide();

    if (response.data === "Ok") {
      CustomClearAllAndReloadScheduler();
    } else if (response.data === "OverGuests") {
      var toastCheckConnection = app.f7.toast.create({
        text: "OverGuests",
        position: "center",
        closeTimeout: 2500
      }).open();
    } else if (response.data === "OverAdults") {
      var toastCheckConnection = app.f7.toast.create({
        text: "OverAdults",
        position: "center",
        closeTimeout: 2500
      }).open();
    }
  } catch (error) {
    app.f7.preloader.hide();
    console.log(error);
  }
}
    